import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  float8: any;
  geography: any;
  geometry: any;
  jsonb: any;
  numeric: any;
  timestamptz: any;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "authUsers" */
export type AuthUsers = {
  __typename?: 'authUsers';
  bio?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** aggregated selection of "authUsers" */
export type AuthUsers_Aggregate = {
  __typename?: 'authUsers_aggregate';
  aggregate?: Maybe<AuthUsers_Aggregate_Fields>;
  nodes: Array<AuthUsers>;
};

/** aggregate fields of "authUsers" */
export type AuthUsers_Aggregate_Fields = {
  __typename?: 'authUsers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthUsers_Max_Fields>;
  min?: Maybe<AuthUsers_Min_Fields>;
};


/** aggregate fields of "authUsers" */
export type AuthUsers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUsers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "authUsers". All fields are combined with a logical 'AND'. */
export type AuthUsers_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUsers_Bool_Exp>>;
  _not?: InputMaybe<AuthUsers_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUsers_Bool_Exp>>;
  bio?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  photoUrl?: InputMaybe<String_Comparison_Exp>;
  verifiedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  websiteUrl?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "authUsers" */
export type AuthUsers_Insert_Input = {
  bio?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AuthUsers_Max_Fields = {
  __typename?: 'authUsers_max_fields';
  bio?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AuthUsers_Min_Fields = {
  __typename?: 'authUsers_min_fields';
  bio?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "authUsers" */
export type AuthUsers_Mutation_Response = {
  __typename?: 'authUsers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUsers>;
};

/** Ordering options when selecting data from "authUsers". */
export type AuthUsers_Order_By = {
  bio?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  photoUrl?: InputMaybe<Order_By>;
  verifiedAt?: InputMaybe<Order_By>;
  websiteUrl?: InputMaybe<Order_By>;
};

/** select columns of table "authUsers" */
export enum AuthUsers_Select_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhotoUrl = 'photoUrl',
  /** column name */
  VerifiedAt = 'verifiedAt',
  /** column name */
  WebsiteUrl = 'websiteUrl'
}

/** input type for updating data in table "authUsers" */
export type AuthUsers_Set_Input = {
  bio?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "authUsers" */
export type AuthUsers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUsers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUsers_Stream_Cursor_Value_Input = {
  bio?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type AuthUsers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUsers_Set_Input>;
  where: AuthUsers_Bool_Exp;
};

/** columns and relationships of "autoTagCounts" */
export type AutoTagCounts = {
  __typename?: 'autoTagCounts';
  count?: Maybe<Scalars['bigint']>;
  tag?: Maybe<Scalars['String']>;
};

/** aggregated selection of "autoTagCounts" */
export type AutoTagCounts_Aggregate = {
  __typename?: 'autoTagCounts_aggregate';
  aggregate?: Maybe<AutoTagCounts_Aggregate_Fields>;
  nodes: Array<AutoTagCounts>;
};

/** aggregate fields of "autoTagCounts" */
export type AutoTagCounts_Aggregate_Fields = {
  __typename?: 'autoTagCounts_aggregate_fields';
  avg?: Maybe<AutoTagCounts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AutoTagCounts_Max_Fields>;
  min?: Maybe<AutoTagCounts_Min_Fields>;
  stddev?: Maybe<AutoTagCounts_Stddev_Fields>;
  stddev_pop?: Maybe<AutoTagCounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AutoTagCounts_Stddev_Samp_Fields>;
  sum?: Maybe<AutoTagCounts_Sum_Fields>;
  var_pop?: Maybe<AutoTagCounts_Var_Pop_Fields>;
  var_samp?: Maybe<AutoTagCounts_Var_Samp_Fields>;
  variance?: Maybe<AutoTagCounts_Variance_Fields>;
};


/** aggregate fields of "autoTagCounts" */
export type AutoTagCounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AutoTagCounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AutoTagCounts_Avg_Fields = {
  __typename?: 'autoTagCounts_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "autoTagCounts". All fields are combined with a logical 'AND'. */
export type AutoTagCounts_Bool_Exp = {
  _and?: InputMaybe<Array<AutoTagCounts_Bool_Exp>>;
  _not?: InputMaybe<AutoTagCounts_Bool_Exp>;
  _or?: InputMaybe<Array<AutoTagCounts_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type AutoTagCounts_Max_Fields = {
  __typename?: 'autoTagCounts_max_fields';
  count?: Maybe<Scalars['bigint']>;
  tag?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AutoTagCounts_Min_Fields = {
  __typename?: 'autoTagCounts_min_fields';
  count?: Maybe<Scalars['bigint']>;
  tag?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "autoTagCounts". */
export type AutoTagCounts_Order_By = {
  count?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
};

/** select columns of table "autoTagCounts" */
export enum AutoTagCounts_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  Tag = 'tag'
}

/** aggregate stddev on columns */
export type AutoTagCounts_Stddev_Fields = {
  __typename?: 'autoTagCounts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AutoTagCounts_Stddev_Pop_Fields = {
  __typename?: 'autoTagCounts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AutoTagCounts_Stddev_Samp_Fields = {
  __typename?: 'autoTagCounts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "autoTagCounts" */
export type AutoTagCounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AutoTagCounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AutoTagCounts_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  tag?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AutoTagCounts_Sum_Fields = {
  __typename?: 'autoTagCounts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type AutoTagCounts_Var_Pop_Fields = {
  __typename?: 'autoTagCounts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AutoTagCounts_Var_Samp_Fields = {
  __typename?: 'autoTagCounts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AutoTagCounts_Variance_Fields = {
  __typename?: 'autoTagCounts_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "awards" */
export type Awards = {
  __typename?: 'awards';
  createdAt: Scalars['timestamptz'];
  data: Scalars['jsonb'];
  id: Scalars['Int'];
  key?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};


/** columns and relationships of "awards" */
export type AwardsDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "awards" */
export type Awards_Aggregate = {
  __typename?: 'awards_aggregate';
  aggregate?: Maybe<Awards_Aggregate_Fields>;
  nodes: Array<Awards>;
};

export type Awards_Aggregate_Bool_Exp = {
  count?: InputMaybe<Awards_Aggregate_Bool_Exp_Count>;
};

export type Awards_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Awards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Awards_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "awards" */
export type Awards_Aggregate_Fields = {
  __typename?: 'awards_aggregate_fields';
  avg?: Maybe<Awards_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Awards_Max_Fields>;
  min?: Maybe<Awards_Min_Fields>;
  stddev?: Maybe<Awards_Stddev_Fields>;
  stddev_pop?: Maybe<Awards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Awards_Stddev_Samp_Fields>;
  sum?: Maybe<Awards_Sum_Fields>;
  var_pop?: Maybe<Awards_Var_Pop_Fields>;
  var_samp?: Maybe<Awards_Var_Samp_Fields>;
  variance?: Maybe<Awards_Variance_Fields>;
};


/** aggregate fields of "awards" */
export type Awards_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Awards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "awards" */
export type Awards_Aggregate_Order_By = {
  avg?: InputMaybe<Awards_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Awards_Max_Order_By>;
  min?: InputMaybe<Awards_Min_Order_By>;
  stddev?: InputMaybe<Awards_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Awards_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Awards_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Awards_Sum_Order_By>;
  var_pop?: InputMaybe<Awards_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Awards_Var_Samp_Order_By>;
  variance?: InputMaybe<Awards_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Awards_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "awards" */
export type Awards_Arr_Rel_Insert_Input = {
  data: Array<Awards_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Awards_On_Conflict>;
};

/** aggregate avg on columns */
export type Awards_Avg_Fields = {
  __typename?: 'awards_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "awards" */
export type Awards_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "awards". All fields are combined with a logical 'AND'. */
export type Awards_Bool_Exp = {
  _and?: InputMaybe<Array<Awards_Bool_Exp>>;
  _not?: InputMaybe<Awards_Bool_Exp>;
  _or?: InputMaybe<Array<Awards_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "awards" */
export enum Awards_Constraint {
  /** unique or primary key constraint on columns "key" */
  AwardsKeyKey = 'awards_key_key',
  /** unique or primary key constraint on columns "id" */
  AwardsPkey = 'awards_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Awards_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Awards_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Awards_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "awards" */
export type Awards_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "awards" */
export type Awards_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Awards_Max_Fields = {
  __typename?: 'awards_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "awards" */
export type Awards_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Awards_Min_Fields = {
  __typename?: 'awards_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "awards" */
export type Awards_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "awards" */
export type Awards_Mutation_Response = {
  __typename?: 'awards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Awards>;
};

/** on_conflict condition type for table "awards" */
export type Awards_On_Conflict = {
  constraint: Awards_Constraint;
  update_columns?: Array<Awards_Update_Column>;
  where?: InputMaybe<Awards_Bool_Exp>;
};

/** Ordering options when selecting data from "awards". */
export type Awards_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: awards */
export type Awards_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Awards_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "awards" */
export enum Awards_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "awards" */
export type Awards_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Awards_Stddev_Fields = {
  __typename?: 'awards_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "awards" */
export type Awards_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Awards_Stddev_Pop_Fields = {
  __typename?: 'awards_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "awards" */
export type Awards_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Awards_Stddev_Samp_Fields = {
  __typename?: 'awards_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "awards" */
export type Awards_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "awards" */
export type Awards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Awards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Awards_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Awards_Sum_Fields = {
  __typename?: 'awards_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "awards" */
export type Awards_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "awards" */
export enum Awards_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

export type Awards_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Awards_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Awards_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Awards_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Awards_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Awards_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Awards_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Awards_Set_Input>;
  where: Awards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Awards_Var_Pop_Fields = {
  __typename?: 'awards_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "awards" */
export type Awards_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Awards_Var_Samp_Fields = {
  __typename?: 'awards_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "awards" */
export type Awards_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Awards_Variance_Fields = {
  __typename?: 'awards_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "awards" */
export type Awards_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "blobs" */
export type Blobs = {
  __typename?: 'blobs';
  createdAt: Scalars['timestamptz'];
  json?: Maybe<Scalars['jsonb']>;
  key: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "blobs" */
export type BlobsJsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "blobs" */
export type Blobs_Aggregate = {
  __typename?: 'blobs_aggregate';
  aggregate?: Maybe<Blobs_Aggregate_Fields>;
  nodes: Array<Blobs>;
};

/** aggregate fields of "blobs" */
export type Blobs_Aggregate_Fields = {
  __typename?: 'blobs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Blobs_Max_Fields>;
  min?: Maybe<Blobs_Min_Fields>;
};


/** aggregate fields of "blobs" */
export type Blobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Blobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Blobs_Append_Input = {
  json?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "blobs". All fields are combined with a logical 'AND'. */
export type Blobs_Bool_Exp = {
  _and?: InputMaybe<Array<Blobs_Bool_Exp>>;
  _not?: InputMaybe<Blobs_Bool_Exp>;
  _or?: InputMaybe<Array<Blobs_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  json?: InputMaybe<Jsonb_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "blobs" */
export enum Blobs_Constraint {
  /** unique or primary key constraint on columns "key" */
  BlobsPkey = 'blobs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Blobs_Delete_At_Path_Input = {
  json?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Blobs_Delete_Elem_Input = {
  json?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Blobs_Delete_Key_Input = {
  json?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "blobs" */
export type Blobs_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  json?: InputMaybe<Scalars['jsonb']>;
  key?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Blobs_Max_Fields = {
  __typename?: 'blobs_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  key?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Blobs_Min_Fields = {
  __typename?: 'blobs_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  key?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "blobs" */
export type Blobs_Mutation_Response = {
  __typename?: 'blobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Blobs>;
};

/** on_conflict condition type for table "blobs" */
export type Blobs_On_Conflict = {
  constraint: Blobs_Constraint;
  update_columns?: Array<Blobs_Update_Column>;
  where?: InputMaybe<Blobs_Bool_Exp>;
};

/** Ordering options when selecting data from "blobs". */
export type Blobs_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  json?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: blobs */
export type Blobs_Pk_Columns_Input = {
  key: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Blobs_Prepend_Input = {
  json?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "blobs" */
export enum Blobs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Json = 'json',
  /** column name */
  Key = 'key',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "blobs" */
export type Blobs_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  json?: InputMaybe<Scalars['jsonb']>;
  key?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "blobs" */
export type Blobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Blobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Blobs_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  json?: InputMaybe<Scalars['jsonb']>;
  key?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "blobs" */
export enum Blobs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Json = 'json',
  /** column name */
  Key = 'key',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Blobs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Blobs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Blobs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Blobs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Blobs_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Blobs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Blobs_Set_Input>;
  where: Blobs_Bool_Exp;
};

/** columns and relationships of "bookmarks" */
export type Bookmarks = {
  __typename?: 'bookmarks';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  review: Reviews;
  reviewId: Scalars['Int'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};

/** aggregated selection of "bookmarks" */
export type Bookmarks_Aggregate = {
  __typename?: 'bookmarks_aggregate';
  aggregate?: Maybe<Bookmarks_Aggregate_Fields>;
  nodes: Array<Bookmarks>;
};

export type Bookmarks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Bookmarks_Aggregate_Bool_Exp_Count>;
};

export type Bookmarks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Bookmarks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Bookmarks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "bookmarks" */
export type Bookmarks_Aggregate_Fields = {
  __typename?: 'bookmarks_aggregate_fields';
  avg?: Maybe<Bookmarks_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Bookmarks_Max_Fields>;
  min?: Maybe<Bookmarks_Min_Fields>;
  stddev?: Maybe<Bookmarks_Stddev_Fields>;
  stddev_pop?: Maybe<Bookmarks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bookmarks_Stddev_Samp_Fields>;
  sum?: Maybe<Bookmarks_Sum_Fields>;
  var_pop?: Maybe<Bookmarks_Var_Pop_Fields>;
  var_samp?: Maybe<Bookmarks_Var_Samp_Fields>;
  variance?: Maybe<Bookmarks_Variance_Fields>;
};


/** aggregate fields of "bookmarks" */
export type Bookmarks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bookmarks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bookmarks" */
export type Bookmarks_Aggregate_Order_By = {
  avg?: InputMaybe<Bookmarks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Bookmarks_Max_Order_By>;
  min?: InputMaybe<Bookmarks_Min_Order_By>;
  stddev?: InputMaybe<Bookmarks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Bookmarks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Bookmarks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Bookmarks_Sum_Order_By>;
  var_pop?: InputMaybe<Bookmarks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Bookmarks_Var_Samp_Order_By>;
  variance?: InputMaybe<Bookmarks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bookmarks" */
export type Bookmarks_Arr_Rel_Insert_Input = {
  data: Array<Bookmarks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Bookmarks_On_Conflict>;
};

/** aggregate avg on columns */
export type Bookmarks_Avg_Fields = {
  __typename?: 'bookmarks_avg_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bookmarks" */
export type Bookmarks_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bookmarks". All fields are combined with a logical 'AND'. */
export type Bookmarks_Bool_Exp = {
  _and?: InputMaybe<Array<Bookmarks_Bool_Exp>>;
  _not?: InputMaybe<Bookmarks_Bool_Exp>;
  _or?: InputMaybe<Array<Bookmarks_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  review?: InputMaybe<Reviews_Bool_Exp>;
  reviewId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bookmarks" */
export enum Bookmarks_Constraint {
  /** unique or primary key constraint on columns "id" */
  BookmarksPkey = 'bookmarks_pkey',
  /** unique or primary key constraint on columns "reviewId", "userId" */
  BookmarksUserIdReviewIdKey = 'bookmarks_userId_reviewId_key'
}

/** input type for incrementing numeric columns in table "bookmarks" */
export type Bookmarks_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  reviewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "bookmarks" */
export type Bookmarks_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<Reviews_Obj_Rel_Insert_Input>;
  reviewId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Bookmarks_Max_Fields = {
  __typename?: 'bookmarks_max_fields';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  reviewId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "bookmarks" */
export type Bookmarks_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Bookmarks_Min_Fields = {
  __typename?: 'bookmarks_min_fields';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  reviewId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "bookmarks" */
export type Bookmarks_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "bookmarks" */
export type Bookmarks_Mutation_Response = {
  __typename?: 'bookmarks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Bookmarks>;
};

/** on_conflict condition type for table "bookmarks" */
export type Bookmarks_On_Conflict = {
  constraint: Bookmarks_Constraint;
  update_columns?: Array<Bookmarks_Update_Column>;
  where?: InputMaybe<Bookmarks_Bool_Exp>;
};

/** Ordering options when selecting data from "bookmarks". */
export type Bookmarks_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review?: InputMaybe<Reviews_Order_By>;
  reviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bookmarks */
export type Bookmarks_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "bookmarks" */
export enum Bookmarks_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ReviewId = 'reviewId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "bookmarks" */
export type Bookmarks_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Bookmarks_Stddev_Fields = {
  __typename?: 'bookmarks_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bookmarks" */
export type Bookmarks_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bookmarks_Stddev_Pop_Fields = {
  __typename?: 'bookmarks_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "bookmarks" */
export type Bookmarks_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bookmarks_Stddev_Samp_Fields = {
  __typename?: 'bookmarks_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "bookmarks" */
export type Bookmarks_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "bookmarks" */
export type Bookmarks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bookmarks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bookmarks_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Bookmarks_Sum_Fields = {
  __typename?: 'bookmarks_sum_fields';
  id?: Maybe<Scalars['Int']>;
  reviewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "bookmarks" */
export type Bookmarks_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** update columns of table "bookmarks" */
export enum Bookmarks_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ReviewId = 'reviewId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Bookmarks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bookmarks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bookmarks_Set_Input>;
  where: Bookmarks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bookmarks_Var_Pop_Fields = {
  __typename?: 'bookmarks_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "bookmarks" */
export type Bookmarks_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bookmarks_Var_Samp_Fields = {
  __typename?: 'bookmarks_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "bookmarks" */
export type Bookmarks_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Bookmarks_Variance_Fields = {
  __typename?: 'bookmarks_variance_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bookmarks" */
export type Bookmarks_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "follows" */
export type Follows = {
  __typename?: 'follows';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  follower: Users;
  followerId: Scalars['String'];
  /** An object relationship */
  following: Users;
  followingId: Scalars['String'];
  id: Scalars['Int'];
};

/** aggregated selection of "follows" */
export type Follows_Aggregate = {
  __typename?: 'follows_aggregate';
  aggregate?: Maybe<Follows_Aggregate_Fields>;
  nodes: Array<Follows>;
};

export type Follows_Aggregate_Bool_Exp = {
  count?: InputMaybe<Follows_Aggregate_Bool_Exp_Count>;
};

export type Follows_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Follows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Follows_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "follows" */
export type Follows_Aggregate_Fields = {
  __typename?: 'follows_aggregate_fields';
  avg?: Maybe<Follows_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Follows_Max_Fields>;
  min?: Maybe<Follows_Min_Fields>;
  stddev?: Maybe<Follows_Stddev_Fields>;
  stddev_pop?: Maybe<Follows_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Follows_Stddev_Samp_Fields>;
  sum?: Maybe<Follows_Sum_Fields>;
  var_pop?: Maybe<Follows_Var_Pop_Fields>;
  var_samp?: Maybe<Follows_Var_Samp_Fields>;
  variance?: Maybe<Follows_Variance_Fields>;
};


/** aggregate fields of "follows" */
export type Follows_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Follows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "follows" */
export type Follows_Aggregate_Order_By = {
  avg?: InputMaybe<Follows_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Follows_Max_Order_By>;
  min?: InputMaybe<Follows_Min_Order_By>;
  stddev?: InputMaybe<Follows_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Follows_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Follows_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Follows_Sum_Order_By>;
  var_pop?: InputMaybe<Follows_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Follows_Var_Samp_Order_By>;
  variance?: InputMaybe<Follows_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "follows" */
export type Follows_Arr_Rel_Insert_Input = {
  data: Array<Follows_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Follows_On_Conflict>;
};

/** aggregate avg on columns */
export type Follows_Avg_Fields = {
  __typename?: 'follows_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "follows" */
export type Follows_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "follows". All fields are combined with a logical 'AND'. */
export type Follows_Bool_Exp = {
  _and?: InputMaybe<Array<Follows_Bool_Exp>>;
  _not?: InputMaybe<Follows_Bool_Exp>;
  _or?: InputMaybe<Array<Follows_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  follower?: InputMaybe<Users_Bool_Exp>;
  followerId?: InputMaybe<String_Comparison_Exp>;
  following?: InputMaybe<Users_Bool_Exp>;
  followingId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "follows" */
export enum Follows_Constraint {
  /** unique or primary key constraint on columns "followingId", "followerId" */
  FollowsFollowerIdFollowingIdKey = 'follows_followerId_followingId_key',
  /** unique or primary key constraint on columns "id" */
  FollowsPkey = 'follows_pkey'
}

/** input type for incrementing numeric columns in table "follows" */
export type Follows_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "follows" */
export type Follows_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  follower?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  followerId?: InputMaybe<Scalars['String']>;
  following?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  followingId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Follows_Max_Fields = {
  __typename?: 'follows_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  followerId?: Maybe<Scalars['String']>;
  followingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "follows" */
export type Follows_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  followerId?: InputMaybe<Order_By>;
  followingId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Follows_Min_Fields = {
  __typename?: 'follows_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  followerId?: Maybe<Scalars['String']>;
  followingId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "follows" */
export type Follows_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  followerId?: InputMaybe<Order_By>;
  followingId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "follows" */
export type Follows_Mutation_Response = {
  __typename?: 'follows_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Follows>;
};

/** on_conflict condition type for table "follows" */
export type Follows_On_Conflict = {
  constraint: Follows_Constraint;
  update_columns?: Array<Follows_Update_Column>;
  where?: InputMaybe<Follows_Bool_Exp>;
};

/** Ordering options when selecting data from "follows". */
export type Follows_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  follower?: InputMaybe<Users_Order_By>;
  followerId?: InputMaybe<Order_By>;
  following?: InputMaybe<Users_Order_By>;
  followingId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: follows */
export type Follows_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "follows" */
export enum Follows_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FollowerId = 'followerId',
  /** column name */
  FollowingId = 'followingId',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "follows" */
export type Follows_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  followerId?: InputMaybe<Scalars['String']>;
  followingId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Follows_Stddev_Fields = {
  __typename?: 'follows_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "follows" */
export type Follows_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Follows_Stddev_Pop_Fields = {
  __typename?: 'follows_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "follows" */
export type Follows_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Follows_Stddev_Samp_Fields = {
  __typename?: 'follows_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "follows" */
export type Follows_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "follows" */
export type Follows_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Follows_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Follows_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  followerId?: InputMaybe<Scalars['String']>;
  followingId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Follows_Sum_Fields = {
  __typename?: 'follows_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "follows" */
export type Follows_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "follows" */
export enum Follows_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FollowerId = 'followerId',
  /** column name */
  FollowingId = 'followingId',
  /** column name */
  Id = 'id'
}

export type Follows_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Follows_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Follows_Set_Input>;
  where: Follows_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Follows_Var_Pop_Fields = {
  __typename?: 'follows_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "follows" */
export type Follows_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Follows_Var_Samp_Fields = {
  __typename?: 'follows_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "follows" */
export type Follows_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Follows_Variance_Fields = {
  __typename?: 'follows_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "follows" */
export type Follows_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "franchises" */
export type Franchises = {
  __typename?: 'franchises';
  autoAddRadius: Scalars['Int'];
  coverUrl?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['float8']>;
  lng?: Maybe<Scalars['float8']>;
  name: Scalars['String'];
  /** An array relationship */
  places: Array<Places>;
  /** An aggregate relationship */
  places_aggregate: Places_Aggregate;
  websiteUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "franchises" */
export type FranchisesPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** columns and relationships of "franchises" */
export type FranchisesPlaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};

/** aggregated selection of "franchises" */
export type Franchises_Aggregate = {
  __typename?: 'franchises_aggregate';
  aggregate?: Maybe<Franchises_Aggregate_Fields>;
  nodes: Array<Franchises>;
};

/** aggregate fields of "franchises" */
export type Franchises_Aggregate_Fields = {
  __typename?: 'franchises_aggregate_fields';
  avg?: Maybe<Franchises_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Franchises_Max_Fields>;
  min?: Maybe<Franchises_Min_Fields>;
  stddev?: Maybe<Franchises_Stddev_Fields>;
  stddev_pop?: Maybe<Franchises_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Franchises_Stddev_Samp_Fields>;
  sum?: Maybe<Franchises_Sum_Fields>;
  var_pop?: Maybe<Franchises_Var_Pop_Fields>;
  var_samp?: Maybe<Franchises_Var_Samp_Fields>;
  variance?: Maybe<Franchises_Variance_Fields>;
};


/** aggregate fields of "franchises" */
export type Franchises_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Franchises_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Franchises_Avg_Fields = {
  __typename?: 'franchises_avg_fields';
  autoAddRadius?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "franchises". All fields are combined with a logical 'AND'. */
export type Franchises_Bool_Exp = {
  _and?: InputMaybe<Array<Franchises_Bool_Exp>>;
  _not?: InputMaybe<Franchises_Bool_Exp>;
  _or?: InputMaybe<Array<Franchises_Bool_Exp>>;
  autoAddRadius?: InputMaybe<Int_Comparison_Exp>;
  coverUrl?: InputMaybe<String_Comparison_Exp>;
  iconUrl?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Places_Bool_Exp>;
  places_aggregate?: InputMaybe<Places_Aggregate_Bool_Exp>;
  websiteUrl?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "franchises" */
export enum Franchises_Constraint {
  /** unique or primary key constraint on columns "name" */
  FranchisesPkey = 'franchises_pkey',
  /** unique or primary key constraint on columns "websiteUrl" */
  FranchisesWebsiteUrlKey = 'franchises_websiteUrl_key'
}

/** input type for incrementing numeric columns in table "franchises" */
export type Franchises_Inc_Input = {
  autoAddRadius?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['float8']>;
  lng?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "franchises" */
export type Franchises_Insert_Input = {
  autoAddRadius?: InputMaybe<Scalars['Int']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['float8']>;
  lng?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  places?: InputMaybe<Places_Arr_Rel_Insert_Input>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Franchises_Max_Fields = {
  __typename?: 'franchises_max_fields';
  autoAddRadius?: Maybe<Scalars['Int']>;
  coverUrl?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['float8']>;
  lng?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Franchises_Min_Fields = {
  __typename?: 'franchises_min_fields';
  autoAddRadius?: Maybe<Scalars['Int']>;
  coverUrl?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['float8']>;
  lng?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "franchises" */
export type Franchises_Mutation_Response = {
  __typename?: 'franchises_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Franchises>;
};

/** input type for inserting object relation for remote table "franchises" */
export type Franchises_Obj_Rel_Insert_Input = {
  data: Franchises_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Franchises_On_Conflict>;
};

/** on_conflict condition type for table "franchises" */
export type Franchises_On_Conflict = {
  constraint: Franchises_Constraint;
  update_columns?: Array<Franchises_Update_Column>;
  where?: InputMaybe<Franchises_Bool_Exp>;
};

/** Ordering options when selecting data from "franchises". */
export type Franchises_Order_By = {
  autoAddRadius?: InputMaybe<Order_By>;
  coverUrl?: InputMaybe<Order_By>;
  iconUrl?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  websiteUrl?: InputMaybe<Order_By>;
};

/** primary key columns input for table: franchises */
export type Franchises_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "franchises" */
export enum Franchises_Select_Column {
  /** column name */
  AutoAddRadius = 'autoAddRadius',
  /** column name */
  CoverUrl = 'coverUrl',
  /** column name */
  IconUrl = 'iconUrl',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Name = 'name',
  /** column name */
  WebsiteUrl = 'websiteUrl'
}

/** input type for updating data in table "franchises" */
export type Franchises_Set_Input = {
  autoAddRadius?: InputMaybe<Scalars['Int']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['float8']>;
  lng?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Franchises_Stddev_Fields = {
  __typename?: 'franchises_stddev_fields';
  autoAddRadius?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Franchises_Stddev_Pop_Fields = {
  __typename?: 'franchises_stddev_pop_fields';
  autoAddRadius?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Franchises_Stddev_Samp_Fields = {
  __typename?: 'franchises_stddev_samp_fields';
  autoAddRadius?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "franchises" */
export type Franchises_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Franchises_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Franchises_Stream_Cursor_Value_Input = {
  autoAddRadius?: InputMaybe<Scalars['Int']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['float8']>;
  lng?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Franchises_Sum_Fields = {
  __typename?: 'franchises_sum_fields';
  autoAddRadius?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['float8']>;
  lng?: Maybe<Scalars['float8']>;
};

/** update columns of table "franchises" */
export enum Franchises_Update_Column {
  /** column name */
  AutoAddRadius = 'autoAddRadius',
  /** column name */
  CoverUrl = 'coverUrl',
  /** column name */
  IconUrl = 'iconUrl',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Name = 'name',
  /** column name */
  WebsiteUrl = 'websiteUrl'
}

export type Franchises_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Franchises_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Franchises_Set_Input>;
  where: Franchises_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Franchises_Var_Pop_Fields = {
  __typename?: 'franchises_var_pop_fields';
  autoAddRadius?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Franchises_Var_Samp_Fields = {
  __typename?: 'franchises_var_samp_fields';
  autoAddRadius?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Franchises_Variance_Fields = {
  __typename?: 'franchises_variance_fields';
  autoAddRadius?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "authUsers" */
  delete_authUsers?: Maybe<AuthUsers_Mutation_Response>;
  /** delete data from the table: "awards" */
  delete_awards?: Maybe<Awards_Mutation_Response>;
  /** delete single row from the table: "awards" */
  delete_awards_by_pk?: Maybe<Awards>;
  /** delete data from the table: "blobs" */
  delete_blobs?: Maybe<Blobs_Mutation_Response>;
  /** delete single row from the table: "blobs" */
  delete_blobs_by_pk?: Maybe<Blobs>;
  /** delete data from the table: "bookmarks" */
  delete_bookmarks?: Maybe<Bookmarks_Mutation_Response>;
  /** delete single row from the table: "bookmarks" */
  delete_bookmarks_by_pk?: Maybe<Bookmarks>;
  /** delete data from the table: "follows" */
  delete_follows?: Maybe<Follows_Mutation_Response>;
  /** delete single row from the table: "follows" */
  delete_follows_by_pk?: Maybe<Follows>;
  /** delete data from the table: "franchises" */
  delete_franchises?: Maybe<Franchises_Mutation_Response>;
  /** delete single row from the table: "franchises" */
  delete_franchises_by_pk?: Maybe<Franchises>;
  /** delete data from the table: "notifications" */
  delete_notifications?: Maybe<Notifications_Mutation_Response>;
  /** delete single row from the table: "notifications" */
  delete_notifications_by_pk?: Maybe<Notifications>;
  /** delete data from the table: "places" */
  delete_places?: Maybe<Places_Mutation_Response>;
  /** delete single row from the table: "places" */
  delete_places_by_pk?: Maybe<Places>;
  /** delete data from the table: "reactions" */
  delete_reactions?: Maybe<Reactions_Mutation_Response>;
  /** delete single row from the table: "reactions" */
  delete_reactions_by_pk?: Maybe<Reactions>;
  /** delete data from the table: "recommendations" */
  delete_recommendations?: Maybe<Recommendations_Mutation_Response>;
  /** delete single row from the table: "recommendations" */
  delete_recommendations_by_pk?: Maybe<Recommendations>;
  /** delete data from the table: "reviews" */
  delete_reviews?: Maybe<Reviews_Mutation_Response>;
  /** delete single row from the table: "reviews" */
  delete_reviews_by_pk?: Maybe<Reviews>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** insert data into the table: "authUsers" */
  insert_authUsers?: Maybe<AuthUsers_Mutation_Response>;
  /** insert a single row into the table: "authUsers" */
  insert_authUsers_one?: Maybe<AuthUsers>;
  /** insert data into the table: "awards" */
  insert_awards?: Maybe<Awards_Mutation_Response>;
  /** insert a single row into the table: "awards" */
  insert_awards_one?: Maybe<Awards>;
  /** insert data into the table: "blobs" */
  insert_blobs?: Maybe<Blobs_Mutation_Response>;
  /** insert a single row into the table: "blobs" */
  insert_blobs_one?: Maybe<Blobs>;
  /** insert data into the table: "bookmarks" */
  insert_bookmarks?: Maybe<Bookmarks_Mutation_Response>;
  /** insert a single row into the table: "bookmarks" */
  insert_bookmarks_one?: Maybe<Bookmarks>;
  /** insert data into the table: "follows" */
  insert_follows?: Maybe<Follows_Mutation_Response>;
  /** insert a single row into the table: "follows" */
  insert_follows_one?: Maybe<Follows>;
  /** insert data into the table: "franchises" */
  insert_franchises?: Maybe<Franchises_Mutation_Response>;
  /** insert a single row into the table: "franchises" */
  insert_franchises_one?: Maybe<Franchises>;
  /** insert data into the table: "notifications" */
  insert_notifications?: Maybe<Notifications_Mutation_Response>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: Maybe<Notifications>;
  /** insert data into the table: "places" */
  insert_places?: Maybe<Places_Mutation_Response>;
  /** insert a single row into the table: "places" */
  insert_places_one?: Maybe<Places>;
  /** insert data into the table: "reactions" */
  insert_reactions?: Maybe<Reactions_Mutation_Response>;
  /** insert a single row into the table: "reactions" */
  insert_reactions_one?: Maybe<Reactions>;
  /** insert data into the table: "recommendations" */
  insert_recommendations?: Maybe<Recommendations_Mutation_Response>;
  /** insert a single row into the table: "recommendations" */
  insert_recommendations_one?: Maybe<Recommendations>;
  /** insert data into the table: "reviews" */
  insert_reviews?: Maybe<Reviews_Mutation_Response>;
  /** insert a single row into the table: "reviews" */
  insert_reviews_one?: Maybe<Reviews>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** update data of the table: "authUsers" */
  update_authUsers?: Maybe<AuthUsers_Mutation_Response>;
  /** update multiples rows of table: "authUsers" */
  update_authUsers_many?: Maybe<Array<Maybe<AuthUsers_Mutation_Response>>>;
  /** update data of the table: "awards" */
  update_awards?: Maybe<Awards_Mutation_Response>;
  /** update single row of the table: "awards" */
  update_awards_by_pk?: Maybe<Awards>;
  /** update multiples rows of table: "awards" */
  update_awards_many?: Maybe<Array<Maybe<Awards_Mutation_Response>>>;
  /** update data of the table: "blobs" */
  update_blobs?: Maybe<Blobs_Mutation_Response>;
  /** update single row of the table: "blobs" */
  update_blobs_by_pk?: Maybe<Blobs>;
  /** update multiples rows of table: "blobs" */
  update_blobs_many?: Maybe<Array<Maybe<Blobs_Mutation_Response>>>;
  /** update data of the table: "bookmarks" */
  update_bookmarks?: Maybe<Bookmarks_Mutation_Response>;
  /** update single row of the table: "bookmarks" */
  update_bookmarks_by_pk?: Maybe<Bookmarks>;
  /** update multiples rows of table: "bookmarks" */
  update_bookmarks_many?: Maybe<Array<Maybe<Bookmarks_Mutation_Response>>>;
  /** update data of the table: "follows" */
  update_follows?: Maybe<Follows_Mutation_Response>;
  /** update single row of the table: "follows" */
  update_follows_by_pk?: Maybe<Follows>;
  /** update multiples rows of table: "follows" */
  update_follows_many?: Maybe<Array<Maybe<Follows_Mutation_Response>>>;
  /** update data of the table: "franchises" */
  update_franchises?: Maybe<Franchises_Mutation_Response>;
  /** update single row of the table: "franchises" */
  update_franchises_by_pk?: Maybe<Franchises>;
  /** update multiples rows of table: "franchises" */
  update_franchises_many?: Maybe<Array<Maybe<Franchises_Mutation_Response>>>;
  /** update data of the table: "notifications" */
  update_notifications?: Maybe<Notifications_Mutation_Response>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: Maybe<Notifications>;
  /** update multiples rows of table: "notifications" */
  update_notifications_many?: Maybe<Array<Maybe<Notifications_Mutation_Response>>>;
  /** update data of the table: "places" */
  update_places?: Maybe<Places_Mutation_Response>;
  /** update single row of the table: "places" */
  update_places_by_pk?: Maybe<Places>;
  /** update multiples rows of table: "places" */
  update_places_many?: Maybe<Array<Maybe<Places_Mutation_Response>>>;
  /** update data of the table: "reactions" */
  update_reactions?: Maybe<Reactions_Mutation_Response>;
  /** update single row of the table: "reactions" */
  update_reactions_by_pk?: Maybe<Reactions>;
  /** update multiples rows of table: "reactions" */
  update_reactions_many?: Maybe<Array<Maybe<Reactions_Mutation_Response>>>;
  /** update data of the table: "recommendations" */
  update_recommendations?: Maybe<Recommendations_Mutation_Response>;
  /** update single row of the table: "recommendations" */
  update_recommendations_by_pk?: Maybe<Recommendations>;
  /** update multiples rows of table: "recommendations" */
  update_recommendations_many?: Maybe<Array<Maybe<Recommendations_Mutation_Response>>>;
  /** update data of the table: "reviews" */
  update_reviews?: Maybe<Reviews_Mutation_Response>;
  /** update single row of the table: "reviews" */
  update_reviews_by_pk?: Maybe<Reviews>;
  /** update multiples rows of table: "reviews" */
  update_reviews_many?: Maybe<Array<Maybe<Reviews_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_AuthUsersArgs = {
  where: AuthUsers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AwardsArgs = {
  where: Awards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Awards_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BlobsArgs = {
  where: Blobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Blobs_By_PkArgs = {
  key: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_BookmarksArgs = {
  where: Bookmarks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bookmarks_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FollowsArgs = {
  where: Follows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Follows_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FranchisesArgs = {
  where: Franchises_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Franchises_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationsArgs = {
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notifications_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PlacesArgs = {
  where: Places_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Places_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ReactionsArgs = {
  where: Reactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reactions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_RecommendationsArgs = {
  where: Recommendations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Recommendations_By_PkArgs = {
  fromUserId: Scalars['String'];
  reviewId: Scalars['Int'];
  toUserId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ReviewsArgs = {
  where: Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reviews_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_AuthUsersArgs = {
  objects: Array<AuthUsers_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_AuthUsers_OneArgs = {
  object: AuthUsers_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_AwardsArgs = {
  objects: Array<Awards_Insert_Input>;
  on_conflict?: InputMaybe<Awards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Awards_OneArgs = {
  object: Awards_Insert_Input;
  on_conflict?: InputMaybe<Awards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BlobsArgs = {
  objects: Array<Blobs_Insert_Input>;
  on_conflict?: InputMaybe<Blobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blobs_OneArgs = {
  object: Blobs_Insert_Input;
  on_conflict?: InputMaybe<Blobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BookmarksArgs = {
  objects: Array<Bookmarks_Insert_Input>;
  on_conflict?: InputMaybe<Bookmarks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bookmarks_OneArgs = {
  object: Bookmarks_Insert_Input;
  on_conflict?: InputMaybe<Bookmarks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FollowsArgs = {
  objects: Array<Follows_Insert_Input>;
  on_conflict?: InputMaybe<Follows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Follows_OneArgs = {
  object: Follows_Insert_Input;
  on_conflict?: InputMaybe<Follows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FranchisesArgs = {
  objects: Array<Franchises_Insert_Input>;
  on_conflict?: InputMaybe<Franchises_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Franchises_OneArgs = {
  object: Franchises_Insert_Input;
  on_conflict?: InputMaybe<Franchises_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationsArgs = {
  objects: Array<Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notifications_OneArgs = {
  object: Notifications_Insert_Input;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlacesArgs = {
  objects: Array<Places_Insert_Input>;
  on_conflict?: InputMaybe<Places_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Places_OneArgs = {
  object: Places_Insert_Input;
  on_conflict?: InputMaybe<Places_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReactionsArgs = {
  objects: Array<Reactions_Insert_Input>;
  on_conflict?: InputMaybe<Reactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reactions_OneArgs = {
  object: Reactions_Insert_Input;
  on_conflict?: InputMaybe<Reactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RecommendationsArgs = {
  objects: Array<Recommendations_Insert_Input>;
  on_conflict?: InputMaybe<Recommendations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recommendations_OneArgs = {
  object: Recommendations_Insert_Input;
  on_conflict?: InputMaybe<Recommendations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReviewsArgs = {
  objects: Array<Reviews_Insert_Input>;
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reviews_OneArgs = {
  object: Reviews_Insert_Input;
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUsersArgs = {
  _set?: InputMaybe<AuthUsers_Set_Input>;
  where: AuthUsers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUsers_ManyArgs = {
  updates: Array<AuthUsers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AwardsArgs = {
  _append?: InputMaybe<Awards_Append_Input>;
  _delete_at_path?: InputMaybe<Awards_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Awards_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Awards_Delete_Key_Input>;
  _inc?: InputMaybe<Awards_Inc_Input>;
  _prepend?: InputMaybe<Awards_Prepend_Input>;
  _set?: InputMaybe<Awards_Set_Input>;
  where: Awards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Awards_By_PkArgs = {
  _append?: InputMaybe<Awards_Append_Input>;
  _delete_at_path?: InputMaybe<Awards_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Awards_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Awards_Delete_Key_Input>;
  _inc?: InputMaybe<Awards_Inc_Input>;
  _prepend?: InputMaybe<Awards_Prepend_Input>;
  _set?: InputMaybe<Awards_Set_Input>;
  pk_columns: Awards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Awards_ManyArgs = {
  updates: Array<Awards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BlobsArgs = {
  _append?: InputMaybe<Blobs_Append_Input>;
  _delete_at_path?: InputMaybe<Blobs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Blobs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Blobs_Delete_Key_Input>;
  _prepend?: InputMaybe<Blobs_Prepend_Input>;
  _set?: InputMaybe<Blobs_Set_Input>;
  where: Blobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Blobs_By_PkArgs = {
  _append?: InputMaybe<Blobs_Append_Input>;
  _delete_at_path?: InputMaybe<Blobs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Blobs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Blobs_Delete_Key_Input>;
  _prepend?: InputMaybe<Blobs_Prepend_Input>;
  _set?: InputMaybe<Blobs_Set_Input>;
  pk_columns: Blobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Blobs_ManyArgs = {
  updates: Array<Blobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BookmarksArgs = {
  _inc?: InputMaybe<Bookmarks_Inc_Input>;
  _set?: InputMaybe<Bookmarks_Set_Input>;
  where: Bookmarks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bookmarks_By_PkArgs = {
  _inc?: InputMaybe<Bookmarks_Inc_Input>;
  _set?: InputMaybe<Bookmarks_Set_Input>;
  pk_columns: Bookmarks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bookmarks_ManyArgs = {
  updates: Array<Bookmarks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FollowsArgs = {
  _inc?: InputMaybe<Follows_Inc_Input>;
  _set?: InputMaybe<Follows_Set_Input>;
  where: Follows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Follows_By_PkArgs = {
  _inc?: InputMaybe<Follows_Inc_Input>;
  _set?: InputMaybe<Follows_Set_Input>;
  pk_columns: Follows_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Follows_ManyArgs = {
  updates: Array<Follows_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FranchisesArgs = {
  _inc?: InputMaybe<Franchises_Inc_Input>;
  _set?: InputMaybe<Franchises_Set_Input>;
  where: Franchises_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Franchises_By_PkArgs = {
  _inc?: InputMaybe<Franchises_Inc_Input>;
  _set?: InputMaybe<Franchises_Set_Input>;
  pk_columns: Franchises_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Franchises_ManyArgs = {
  updates: Array<Franchises_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationsArgs = {
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_By_PkArgs = {
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  pk_columns: Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_ManyArgs = {
  updates: Array<Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlacesArgs = {
  _append?: InputMaybe<Places_Append_Input>;
  _delete_at_path?: InputMaybe<Places_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Places_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Places_Delete_Key_Input>;
  _inc?: InputMaybe<Places_Inc_Input>;
  _prepend?: InputMaybe<Places_Prepend_Input>;
  _set?: InputMaybe<Places_Set_Input>;
  where: Places_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Places_By_PkArgs = {
  _append?: InputMaybe<Places_Append_Input>;
  _delete_at_path?: InputMaybe<Places_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Places_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Places_Delete_Key_Input>;
  _inc?: InputMaybe<Places_Inc_Input>;
  _prepend?: InputMaybe<Places_Prepend_Input>;
  _set?: InputMaybe<Places_Set_Input>;
  pk_columns: Places_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Places_ManyArgs = {
  updates: Array<Places_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReactionsArgs = {
  _inc?: InputMaybe<Reactions_Inc_Input>;
  _set?: InputMaybe<Reactions_Set_Input>;
  where: Reactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reactions_By_PkArgs = {
  _inc?: InputMaybe<Reactions_Inc_Input>;
  _set?: InputMaybe<Reactions_Set_Input>;
  pk_columns: Reactions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reactions_ManyArgs = {
  updates: Array<Reactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RecommendationsArgs = {
  _inc?: InputMaybe<Recommendations_Inc_Input>;
  _set?: InputMaybe<Recommendations_Set_Input>;
  where: Recommendations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Recommendations_By_PkArgs = {
  _inc?: InputMaybe<Recommendations_Inc_Input>;
  _set?: InputMaybe<Recommendations_Set_Input>;
  pk_columns: Recommendations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Recommendations_ManyArgs = {
  updates: Array<Recommendations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReviewsArgs = {
  _append?: InputMaybe<Reviews_Append_Input>;
  _delete_at_path?: InputMaybe<Reviews_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reviews_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reviews_Delete_Key_Input>;
  _inc?: InputMaybe<Reviews_Inc_Input>;
  _prepend?: InputMaybe<Reviews_Prepend_Input>;
  _set?: InputMaybe<Reviews_Set_Input>;
  where: Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reviews_By_PkArgs = {
  _append?: InputMaybe<Reviews_Append_Input>;
  _delete_at_path?: InputMaybe<Reviews_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reviews_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reviews_Delete_Key_Input>;
  _inc?: InputMaybe<Reviews_Inc_Input>;
  _prepend?: InputMaybe<Reviews_Prepend_Input>;
  _set?: InputMaybe<Reviews_Set_Input>;
  pk_columns: Reviews_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reviews_ManyArgs = {
  updates: Array<Reviews_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};

export type NearbyPlaces_Args = {
  latitude?: InputMaybe<Scalars['float8']>;
  longitude?: InputMaybe<Scalars['float8']>;
  radius?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "notifications" */
export type Notifications = {
  __typename?: 'notifications';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  fromUser?: Maybe<Users>;
  fromUserId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  key?: Maybe<Scalars['String']>;
  pushSentAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  review?: Maybe<Reviews>;
  reviewId?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  /** An object relationship */
  toUser: Users;
  toUserId: Scalars['String'];
  type: Scalars['String'];
  viewedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "notifications" */
export type Notifications_Aggregate = {
  __typename?: 'notifications_aggregate';
  aggregate?: Maybe<Notifications_Aggregate_Fields>;
  nodes: Array<Notifications>;
};

export type Notifications_Aggregate_Bool_Exp = {
  count?: InputMaybe<Notifications_Aggregate_Bool_Exp_Count>;
};

export type Notifications_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Notifications_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notifications" */
export type Notifications_Aggregate_Fields = {
  __typename?: 'notifications_aggregate_fields';
  avg?: Maybe<Notifications_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Notifications_Max_Fields>;
  min?: Maybe<Notifications_Min_Fields>;
  stddev?: Maybe<Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<Notifications_Sum_Fields>;
  var_pop?: Maybe<Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<Notifications_Var_Samp_Fields>;
  variance?: Maybe<Notifications_Variance_Fields>;
};


/** aggregate fields of "notifications" */
export type Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notifications" */
export type Notifications_Aggregate_Order_By = {
  avg?: InputMaybe<Notifications_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notifications_Max_Order_By>;
  min?: InputMaybe<Notifications_Min_Order_By>;
  stddev?: InputMaybe<Notifications_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Notifications_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Notifications_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Notifications_Sum_Order_By>;
  var_pop?: InputMaybe<Notifications_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Notifications_Var_Samp_Order_By>;
  variance?: InputMaybe<Notifications_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notifications" */
export type Notifications_Arr_Rel_Insert_Input = {
  data: Array<Notifications_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};

/** aggregate avg on columns */
export type Notifications_Avg_Fields = {
  __typename?: 'notifications_avg_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notifications" */
export type Notifications_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Notifications_Bool_Exp>>;
  _not?: InputMaybe<Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Notifications_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fromUser?: InputMaybe<Users_Bool_Exp>;
  fromUserId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  pushSentAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  review?: InputMaybe<Reviews_Bool_Exp>;
  reviewId?: InputMaybe<Int_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  toUser?: InputMaybe<Users_Bool_Exp>;
  toUserId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  viewedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "notifications" */
export enum Notifications_Constraint {
  /** unique or primary key constraint on columns "key" */
  NotificationsKeyKey = 'notifications_key_key',
  /** unique or primary key constraint on columns "id" */
  NotificationsPkey = 'notifications_pkey'
}

/** input type for incrementing numeric columns in table "notifications" */
export type Notifications_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  reviewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notifications" */
export type Notifications_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  fromUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  pushSentAt?: InputMaybe<Scalars['timestamptz']>;
  review?: InputMaybe<Reviews_Obj_Rel_Insert_Input>;
  reviewId?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  toUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  toUserId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Notifications_Max_Fields = {
  __typename?: 'notifications_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fromUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  pushSentAt?: Maybe<Scalars['timestamptz']>;
  reviewId?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  toUserId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  viewedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "notifications" */
export type Notifications_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fromUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  pushSentAt?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  toUserId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  viewedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notifications_Min_Fields = {
  __typename?: 'notifications_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fromUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  pushSentAt?: Maybe<Scalars['timestamptz']>;
  reviewId?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  toUserId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  viewedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "notifications" */
export type Notifications_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fromUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  pushSentAt?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  toUserId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  viewedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notifications" */
export type Notifications_Mutation_Response = {
  __typename?: 'notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notifications>;
};

/** on_conflict condition type for table "notifications" */
export type Notifications_On_Conflict = {
  constraint: Notifications_Constraint;
  update_columns?: Array<Notifications_Update_Column>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "notifications". */
export type Notifications_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fromUser?: InputMaybe<Users_Order_By>;
  fromUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  pushSentAt?: InputMaybe<Order_By>;
  review?: InputMaybe<Reviews_Order_By>;
  reviewId?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  toUser?: InputMaybe<Users_Order_By>;
  toUserId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  viewedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notifications */
export type Notifications_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "notifications" */
export enum Notifications_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FromUserId = 'fromUserId',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  PushSentAt = 'pushSentAt',
  /** column name */
  ReviewId = 'reviewId',
  /** column name */
  Text = 'text',
  /** column name */
  ToUserId = 'toUserId',
  /** column name */
  Type = 'type',
  /** column name */
  ViewedAt = 'viewedAt'
}

/** input type for updating data in table "notifications" */
export type Notifications_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  pushSentAt?: InputMaybe<Scalars['timestamptz']>;
  reviewId?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  toUserId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Notifications_Stddev_Fields = {
  __typename?: 'notifications_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notifications" */
export type Notifications_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Notifications_Stddev_Pop_Fields = {
  __typename?: 'notifications_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notifications" */
export type Notifications_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Notifications_Stddev_Samp_Fields = {
  __typename?: 'notifications_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notifications" */
export type Notifications_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notifications" */
export type Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notifications_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  pushSentAt?: InputMaybe<Scalars['timestamptz']>;
  reviewId?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  toUserId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Notifications_Sum_Fields = {
  __typename?: 'notifications_sum_fields';
  id?: Maybe<Scalars['Int']>;
  reviewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "notifications" */
export type Notifications_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** update columns of table "notifications" */
export enum Notifications_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FromUserId = 'fromUserId',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  PushSentAt = 'pushSentAt',
  /** column name */
  ReviewId = 'reviewId',
  /** column name */
  Text = 'text',
  /** column name */
  ToUserId = 'toUserId',
  /** column name */
  Type = 'type',
  /** column name */
  ViewedAt = 'viewedAt'
}

export type Notifications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notifications_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notifications_Set_Input>;
  where: Notifications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notifications_Var_Pop_Fields = {
  __typename?: 'notifications_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notifications" */
export type Notifications_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Notifications_Var_Samp_Fields = {
  __typename?: 'notifications_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notifications" */
export type Notifications_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Notifications_Variance_Fields = {
  __typename?: 'notifications_variance_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notifications" */
export type Notifications_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts = {
  __typename?: 'placeEarnedReactionCounts';
  count?: Maybe<Scalars['bigint']>;
  placeId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Aggregate = {
  __typename?: 'placeEarnedReactionCounts_aggregate';
  aggregate?: Maybe<PlaceEarnedReactionCounts_Aggregate_Fields>;
  nodes: Array<PlaceEarnedReactionCounts>;
};

export type PlaceEarnedReactionCounts_Aggregate_Bool_Exp = {
  count?: InputMaybe<PlaceEarnedReactionCounts_Aggregate_Bool_Exp_Count>;
};

export type PlaceEarnedReactionCounts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PlaceEarnedReactionCounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlaceEarnedReactionCounts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Aggregate_Fields = {
  __typename?: 'placeEarnedReactionCounts_aggregate_fields';
  avg?: Maybe<PlaceEarnedReactionCounts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PlaceEarnedReactionCounts_Max_Fields>;
  min?: Maybe<PlaceEarnedReactionCounts_Min_Fields>;
  stddev?: Maybe<PlaceEarnedReactionCounts_Stddev_Fields>;
  stddev_pop?: Maybe<PlaceEarnedReactionCounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PlaceEarnedReactionCounts_Stddev_Samp_Fields>;
  sum?: Maybe<PlaceEarnedReactionCounts_Sum_Fields>;
  var_pop?: Maybe<PlaceEarnedReactionCounts_Var_Pop_Fields>;
  var_samp?: Maybe<PlaceEarnedReactionCounts_Var_Samp_Fields>;
  variance?: Maybe<PlaceEarnedReactionCounts_Variance_Fields>;
};


/** aggregate fields of "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PlaceEarnedReactionCounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Aggregate_Order_By = {
  avg?: InputMaybe<PlaceEarnedReactionCounts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PlaceEarnedReactionCounts_Max_Order_By>;
  min?: InputMaybe<PlaceEarnedReactionCounts_Min_Order_By>;
  stddev?: InputMaybe<PlaceEarnedReactionCounts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PlaceEarnedReactionCounts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PlaceEarnedReactionCounts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PlaceEarnedReactionCounts_Sum_Order_By>;
  var_pop?: InputMaybe<PlaceEarnedReactionCounts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PlaceEarnedReactionCounts_Var_Samp_Order_By>;
  variance?: InputMaybe<PlaceEarnedReactionCounts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Arr_Rel_Insert_Input = {
  data: Array<PlaceEarnedReactionCounts_Insert_Input>;
};

/** aggregate avg on columns */
export type PlaceEarnedReactionCounts_Avg_Fields = {
  __typename?: 'placeEarnedReactionCounts_avg_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "placeEarnedReactionCounts". All fields are combined with a logical 'AND'. */
export type PlaceEarnedReactionCounts_Bool_Exp = {
  _and?: InputMaybe<Array<PlaceEarnedReactionCounts_Bool_Exp>>;
  _not?: InputMaybe<PlaceEarnedReactionCounts_Bool_Exp>;
  _or?: InputMaybe<Array<PlaceEarnedReactionCounts_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  placeId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Insert_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  placeId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlaceEarnedReactionCounts_Max_Fields = {
  __typename?: 'placeEarnedReactionCounts_max_fields';
  count?: Maybe<Scalars['bigint']>;
  placeId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PlaceEarnedReactionCounts_Min_Fields = {
  __typename?: 'placeEarnedReactionCounts_min_fields';
  count?: Maybe<Scalars['bigint']>;
  placeId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "placeEarnedReactionCounts". */
export type PlaceEarnedReactionCounts_Order_By = {
  count?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "placeEarnedReactionCounts" */
export enum PlaceEarnedReactionCounts_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  PlaceId = 'placeId',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type PlaceEarnedReactionCounts_Stddev_Fields = {
  __typename?: 'placeEarnedReactionCounts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PlaceEarnedReactionCounts_Stddev_Pop_Fields = {
  __typename?: 'placeEarnedReactionCounts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PlaceEarnedReactionCounts_Stddev_Samp_Fields = {
  __typename?: 'placeEarnedReactionCounts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PlaceEarnedReactionCounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PlaceEarnedReactionCounts_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  placeId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PlaceEarnedReactionCounts_Sum_Fields = {
  __typename?: 'placeEarnedReactionCounts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
  placeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type PlaceEarnedReactionCounts_Var_Pop_Fields = {
  __typename?: 'placeEarnedReactionCounts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PlaceEarnedReactionCounts_Var_Samp_Fields = {
  __typename?: 'placeEarnedReactionCounts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PlaceEarnedReactionCounts_Variance_Fields = {
  __typename?: 'placeEarnedReactionCounts_variance_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "placeEarnedReactionCounts" */
export type PlaceEarnedReactionCounts_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "places" */
export type Places = {
  __typename?: 'places';
  address?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  coverUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  franchise?: Maybe<Franchises>;
  franchiseName?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  googlePriceLevel?: Maybe<Scalars['Int']>;
  googleRating?: Maybe<Scalars['numeric']>;
  googleRatingsCount?: Maybe<Scalars['Int']>;
  googleSummary?: Maybe<Scalars['String']>;
  googleUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lat?: Maybe<Scalars['float8']>;
  lng?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geography']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  priceLevel?: Maybe<Scalars['Int']>;
  /** An array relationship */
  reactionCounts: Array<PlaceEarnedReactionCounts>;
  /** An aggregate relationship */
  reactionCounts_aggregate: PlaceEarnedReactionCounts_Aggregate;
  /** An array relationship */
  reviews: Array<Reviews>;
  reviewsCount: Scalars['Int'];
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  state?: Maybe<Scalars['String']>;
  tags: Scalars['jsonb'];
  updatedAt: Scalars['timestamptz'];
  websiteUrl?: Maybe<Scalars['String']>;
  yelpCategories: Scalars['jsonb'];
  yelpId?: Maybe<Scalars['String']>;
  yelpPriceLevel?: Maybe<Scalars['Int']>;
  yelpRating?: Maybe<Scalars['numeric']>;
  yelpRatingsCount?: Maybe<Scalars['Int']>;
  yelpUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "places" */
export type PlacesReactionCountsArgs = {
  distinct_on?: InputMaybe<Array<PlaceEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlaceEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<PlaceEarnedReactionCounts_Bool_Exp>;
};


/** columns and relationships of "places" */
export type PlacesReactionCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlaceEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlaceEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<PlaceEarnedReactionCounts_Bool_Exp>;
};


/** columns and relationships of "places" */
export type PlacesReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


/** columns and relationships of "places" */
export type PlacesReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


/** columns and relationships of "places" */
export type PlacesTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "places" */
export type PlacesYelpCategoriesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "places" */
export type Places_Aggregate = {
  __typename?: 'places_aggregate';
  aggregate?: Maybe<Places_Aggregate_Fields>;
  nodes: Array<Places>;
};

export type Places_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Places_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Places_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Places_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Places_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Places_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Places_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Places_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Places_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Places_Aggregate_Bool_Exp_Var_Samp>;
};

export type Places_Aggregate_Bool_Exp_Avg = {
  arguments: Places_Select_Column_Places_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Places_Aggregate_Bool_Exp_Corr = {
  arguments: Places_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Places_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Places_Select_Column_Places_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Places_Select_Column_Places_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Places_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Places_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Places_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Places_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Places_Select_Column_Places_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Places_Select_Column_Places_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Places_Aggregate_Bool_Exp_Max = {
  arguments: Places_Select_Column_Places_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Places_Aggregate_Bool_Exp_Min = {
  arguments: Places_Select_Column_Places_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Places_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Places_Select_Column_Places_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Places_Aggregate_Bool_Exp_Sum = {
  arguments: Places_Select_Column_Places_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Places_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Places_Select_Column_Places_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "places" */
export type Places_Aggregate_Fields = {
  __typename?: 'places_aggregate_fields';
  avg?: Maybe<Places_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Places_Max_Fields>;
  min?: Maybe<Places_Min_Fields>;
  stddev?: Maybe<Places_Stddev_Fields>;
  stddev_pop?: Maybe<Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Places_Stddev_Samp_Fields>;
  sum?: Maybe<Places_Sum_Fields>;
  var_pop?: Maybe<Places_Var_Pop_Fields>;
  var_samp?: Maybe<Places_Var_Samp_Fields>;
  variance?: Maybe<Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "places" */
export type Places_Aggregate_Order_By = {
  avg?: InputMaybe<Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Places_Max_Order_By>;
  min?: InputMaybe<Places_Min_Order_By>;
  stddev?: InputMaybe<Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Places_Sum_Order_By>;
  var_pop?: InputMaybe<Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Places_Var_Samp_Order_By>;
  variance?: InputMaybe<Places_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Places_Append_Input = {
  tags?: InputMaybe<Scalars['jsonb']>;
  yelpCategories?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "places" */
export type Places_Arr_Rel_Insert_Input = {
  data: Array<Places_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Places_On_Conflict>;
};

/** aggregate avg on columns */
export type Places_Avg_Fields = {
  __typename?: 'places_avg_fields';
  googlePriceLevel?: Maybe<Scalars['Float']>;
  googleRating?: Maybe<Scalars['Float']>;
  googleRatingsCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  priceLevel?: Maybe<Scalars['Float']>;
  reviewsCount?: Maybe<Scalars['Float']>;
  yelpPriceLevel?: Maybe<Scalars['Float']>;
  yelpRating?: Maybe<Scalars['Float']>;
  yelpRatingsCount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "places" */
export type Places_Avg_Order_By = {
  googlePriceLevel?: InputMaybe<Order_By>;
  googleRating?: InputMaybe<Order_By>;
  googleRatingsCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  priceLevel?: InputMaybe<Order_By>;
  reviewsCount?: InputMaybe<Order_By>;
  yelpPriceLevel?: InputMaybe<Order_By>;
  yelpRating?: InputMaybe<Order_By>;
  yelpRatingsCount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type Places_Bool_Exp = {
  _and?: InputMaybe<Array<Places_Bool_Exp>>;
  _not?: InputMaybe<Places_Bool_Exp>;
  _or?: InputMaybe<Array<Places_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  coverUrl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  franchise?: InputMaybe<Franchises_Bool_Exp>;
  franchiseName?: InputMaybe<String_Comparison_Exp>;
  googlePlaceId?: InputMaybe<String_Comparison_Exp>;
  googlePriceLevel?: InputMaybe<Int_Comparison_Exp>;
  googleRating?: InputMaybe<Numeric_Comparison_Exp>;
  googleRatingsCount?: InputMaybe<Int_Comparison_Exp>;
  googleSummary?: InputMaybe<String_Comparison_Exp>;
  googleUrl?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  priceLevel?: InputMaybe<Int_Comparison_Exp>;
  reactionCounts?: InputMaybe<PlaceEarnedReactionCounts_Bool_Exp>;
  reactionCounts_aggregate?: InputMaybe<PlaceEarnedReactionCounts_Aggregate_Bool_Exp>;
  reviews?: InputMaybe<Reviews_Bool_Exp>;
  reviewsCount?: InputMaybe<Int_Comparison_Exp>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  websiteUrl?: InputMaybe<String_Comparison_Exp>;
  yelpCategories?: InputMaybe<Jsonb_Comparison_Exp>;
  yelpId?: InputMaybe<String_Comparison_Exp>;
  yelpPriceLevel?: InputMaybe<Int_Comparison_Exp>;
  yelpRating?: InputMaybe<Numeric_Comparison_Exp>;
  yelpRatingsCount?: InputMaybe<Int_Comparison_Exp>;
  yelpUrl?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "places" */
export enum Places_Constraint {
  /** unique or primary key constraint on columns "googlePlaceId" */
  PlacesGooglePlaceIdKey = 'places_googlePlaceId_key',
  /** unique or primary key constraint on columns "id" */
  PlacesPkey = 'places_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Places_Delete_At_Path_Input = {
  tags?: InputMaybe<Array<Scalars['String']>>;
  yelpCategories?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Places_Delete_Elem_Input = {
  tags?: InputMaybe<Scalars['Int']>;
  yelpCategories?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Places_Delete_Key_Input = {
  tags?: InputMaybe<Scalars['String']>;
  yelpCategories?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "places" */
export type Places_Inc_Input = {
  googlePriceLevel?: InputMaybe<Scalars['Int']>;
  googleRating?: InputMaybe<Scalars['numeric']>;
  googleRatingsCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['float8']>;
  lng?: InputMaybe<Scalars['float8']>;
  priceLevel?: InputMaybe<Scalars['Int']>;
  reviewsCount?: InputMaybe<Scalars['Int']>;
  yelpPriceLevel?: InputMaybe<Scalars['Int']>;
  yelpRating?: InputMaybe<Scalars['numeric']>;
  yelpRatingsCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "places" */
export type Places_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  franchise?: InputMaybe<Franchises_Obj_Rel_Insert_Input>;
  franchiseName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  googlePriceLevel?: InputMaybe<Scalars['Int']>;
  googleRating?: InputMaybe<Scalars['numeric']>;
  googleRatingsCount?: InputMaybe<Scalars['Int']>;
  googleSummary?: InputMaybe<Scalars['String']>;
  googleUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['float8']>;
  lng?: InputMaybe<Scalars['float8']>;
  location?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  priceLevel?: InputMaybe<Scalars['Int']>;
  reactionCounts?: InputMaybe<PlaceEarnedReactionCounts_Arr_Rel_Insert_Input>;
  reviews?: InputMaybe<Reviews_Arr_Rel_Insert_Input>;
  reviewsCount?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  yelpCategories?: InputMaybe<Scalars['jsonb']>;
  yelpId?: InputMaybe<Scalars['String']>;
  yelpPriceLevel?: InputMaybe<Scalars['Int']>;
  yelpRating?: InputMaybe<Scalars['numeric']>;
  yelpRatingsCount?: InputMaybe<Scalars['Int']>;
  yelpUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Places_Max_Fields = {
  __typename?: 'places_max_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  coverUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  franchiseName?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  googlePriceLevel?: Maybe<Scalars['Int']>;
  googleRating?: Maybe<Scalars['numeric']>;
  googleRatingsCount?: Maybe<Scalars['Int']>;
  googleSummary?: Maybe<Scalars['String']>;
  googleUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['float8']>;
  lng?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  priceLevel?: Maybe<Scalars['Int']>;
  reviewsCount?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  websiteUrl?: Maybe<Scalars['String']>;
  yelpId?: Maybe<Scalars['String']>;
  yelpPriceLevel?: Maybe<Scalars['Int']>;
  yelpRating?: Maybe<Scalars['numeric']>;
  yelpRatingsCount?: Maybe<Scalars['Int']>;
  yelpUrl?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "places" */
export type Places_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  coverUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  franchiseName?: InputMaybe<Order_By>;
  googlePlaceId?: InputMaybe<Order_By>;
  googlePriceLevel?: InputMaybe<Order_By>;
  googleRating?: InputMaybe<Order_By>;
  googleRatingsCount?: InputMaybe<Order_By>;
  googleSummary?: InputMaybe<Order_By>;
  googleUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  priceLevel?: InputMaybe<Order_By>;
  reviewsCount?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  websiteUrl?: InputMaybe<Order_By>;
  yelpId?: InputMaybe<Order_By>;
  yelpPriceLevel?: InputMaybe<Order_By>;
  yelpRating?: InputMaybe<Order_By>;
  yelpRatingsCount?: InputMaybe<Order_By>;
  yelpUrl?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Places_Min_Fields = {
  __typename?: 'places_min_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  coverUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  franchiseName?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  googlePriceLevel?: Maybe<Scalars['Int']>;
  googleRating?: Maybe<Scalars['numeric']>;
  googleRatingsCount?: Maybe<Scalars['Int']>;
  googleSummary?: Maybe<Scalars['String']>;
  googleUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['float8']>;
  lng?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  priceLevel?: Maybe<Scalars['Int']>;
  reviewsCount?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  websiteUrl?: Maybe<Scalars['String']>;
  yelpId?: Maybe<Scalars['String']>;
  yelpPriceLevel?: Maybe<Scalars['Int']>;
  yelpRating?: Maybe<Scalars['numeric']>;
  yelpRatingsCount?: Maybe<Scalars['Int']>;
  yelpUrl?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "places" */
export type Places_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  coverUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  franchiseName?: InputMaybe<Order_By>;
  googlePlaceId?: InputMaybe<Order_By>;
  googlePriceLevel?: InputMaybe<Order_By>;
  googleRating?: InputMaybe<Order_By>;
  googleRatingsCount?: InputMaybe<Order_By>;
  googleSummary?: InputMaybe<Order_By>;
  googleUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  priceLevel?: InputMaybe<Order_By>;
  reviewsCount?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  websiteUrl?: InputMaybe<Order_By>;
  yelpId?: InputMaybe<Order_By>;
  yelpPriceLevel?: InputMaybe<Order_By>;
  yelpRating?: InputMaybe<Order_By>;
  yelpRatingsCount?: InputMaybe<Order_By>;
  yelpUrl?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "places" */
export type Places_Mutation_Response = {
  __typename?: 'places_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Places>;
};

/** input type for inserting object relation for remote table "places" */
export type Places_Obj_Rel_Insert_Input = {
  data: Places_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Places_On_Conflict>;
};

/** on_conflict condition type for table "places" */
export type Places_On_Conflict = {
  constraint: Places_Constraint;
  update_columns?: Array<Places_Update_Column>;
  where?: InputMaybe<Places_Bool_Exp>;
};

/** Ordering options when selecting data from "places". */
export type Places_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  coverUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  franchise?: InputMaybe<Franchises_Order_By>;
  franchiseName?: InputMaybe<Order_By>;
  googlePlaceId?: InputMaybe<Order_By>;
  googlePriceLevel?: InputMaybe<Order_By>;
  googleRating?: InputMaybe<Order_By>;
  googleRatingsCount?: InputMaybe<Order_By>;
  googleSummary?: InputMaybe<Order_By>;
  googleUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  priceLevel?: InputMaybe<Order_By>;
  reactionCounts_aggregate?: InputMaybe<PlaceEarnedReactionCounts_Aggregate_Order_By>;
  reviewsCount?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  websiteUrl?: InputMaybe<Order_By>;
  yelpCategories?: InputMaybe<Order_By>;
  yelpId?: InputMaybe<Order_By>;
  yelpPriceLevel?: InputMaybe<Order_By>;
  yelpRating?: InputMaybe<Order_By>;
  yelpRatingsCount?: InputMaybe<Order_By>;
  yelpUrl?: InputMaybe<Order_By>;
};

/** primary key columns input for table: places */
export type Places_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Places_Prepend_Input = {
  tags?: InputMaybe<Scalars['jsonb']>;
  yelpCategories?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "places" */
export enum Places_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CoverUrl = 'coverUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FranchiseName = 'franchiseName',
  /** column name */
  GooglePlaceId = 'googlePlaceId',
  /** column name */
  GooglePriceLevel = 'googlePriceLevel',
  /** column name */
  GoogleRating = 'googleRating',
  /** column name */
  GoogleRatingsCount = 'googleRatingsCount',
  /** column name */
  GoogleSummary = 'googleSummary',
  /** column name */
  GoogleUrl = 'googleUrl',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PriceLevel = 'priceLevel',
  /** column name */
  ReviewsCount = 'reviewsCount',
  /** column name */
  State = 'state',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  YelpCategories = 'yelpCategories',
  /** column name */
  YelpId = 'yelpId',
  /** column name */
  YelpPriceLevel = 'yelpPriceLevel',
  /** column name */
  YelpRating = 'yelpRating',
  /** column name */
  YelpRatingsCount = 'yelpRatingsCount',
  /** column name */
  YelpUrl = 'yelpUrl'
}

/** select "places_aggregate_bool_exp_avg_arguments_columns" columns of table "places" */
export enum Places_Select_Column_Places_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "places_aggregate_bool_exp_corr_arguments_columns" columns of table "places" */
export enum Places_Select_Column_Places_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "places_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "places" */
export enum Places_Select_Column_Places_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "places_aggregate_bool_exp_max_arguments_columns" columns of table "places" */
export enum Places_Select_Column_Places_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "places_aggregate_bool_exp_min_arguments_columns" columns of table "places" */
export enum Places_Select_Column_Places_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "places_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "places" */
export enum Places_Select_Column_Places_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "places_aggregate_bool_exp_sum_arguments_columns" columns of table "places" */
export enum Places_Select_Column_Places_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** select "places_aggregate_bool_exp_var_samp_arguments_columns" columns of table "places" */
export enum Places_Select_Column_Places_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** input type for updating data in table "places" */
export type Places_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  franchiseName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  googlePriceLevel?: InputMaybe<Scalars['Int']>;
  googleRating?: InputMaybe<Scalars['numeric']>;
  googleRatingsCount?: InputMaybe<Scalars['Int']>;
  googleSummary?: InputMaybe<Scalars['String']>;
  googleUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['float8']>;
  lng?: InputMaybe<Scalars['float8']>;
  location?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  priceLevel?: InputMaybe<Scalars['Int']>;
  reviewsCount?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  yelpCategories?: InputMaybe<Scalars['jsonb']>;
  yelpId?: InputMaybe<Scalars['String']>;
  yelpPriceLevel?: InputMaybe<Scalars['Int']>;
  yelpRating?: InputMaybe<Scalars['numeric']>;
  yelpRatingsCount?: InputMaybe<Scalars['Int']>;
  yelpUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Places_Stddev_Fields = {
  __typename?: 'places_stddev_fields';
  googlePriceLevel?: Maybe<Scalars['Float']>;
  googleRating?: Maybe<Scalars['Float']>;
  googleRatingsCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  priceLevel?: Maybe<Scalars['Float']>;
  reviewsCount?: Maybe<Scalars['Float']>;
  yelpPriceLevel?: Maybe<Scalars['Float']>;
  yelpRating?: Maybe<Scalars['Float']>;
  yelpRatingsCount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "places" */
export type Places_Stddev_Order_By = {
  googlePriceLevel?: InputMaybe<Order_By>;
  googleRating?: InputMaybe<Order_By>;
  googleRatingsCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  priceLevel?: InputMaybe<Order_By>;
  reviewsCount?: InputMaybe<Order_By>;
  yelpPriceLevel?: InputMaybe<Order_By>;
  yelpRating?: InputMaybe<Order_By>;
  yelpRatingsCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Places_Stddev_Pop_Fields = {
  __typename?: 'places_stddev_pop_fields';
  googlePriceLevel?: Maybe<Scalars['Float']>;
  googleRating?: Maybe<Scalars['Float']>;
  googleRatingsCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  priceLevel?: Maybe<Scalars['Float']>;
  reviewsCount?: Maybe<Scalars['Float']>;
  yelpPriceLevel?: Maybe<Scalars['Float']>;
  yelpRating?: Maybe<Scalars['Float']>;
  yelpRatingsCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "places" */
export type Places_Stddev_Pop_Order_By = {
  googlePriceLevel?: InputMaybe<Order_By>;
  googleRating?: InputMaybe<Order_By>;
  googleRatingsCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  priceLevel?: InputMaybe<Order_By>;
  reviewsCount?: InputMaybe<Order_By>;
  yelpPriceLevel?: InputMaybe<Order_By>;
  yelpRating?: InputMaybe<Order_By>;
  yelpRatingsCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Places_Stddev_Samp_Fields = {
  __typename?: 'places_stddev_samp_fields';
  googlePriceLevel?: Maybe<Scalars['Float']>;
  googleRating?: Maybe<Scalars['Float']>;
  googleRatingsCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  priceLevel?: Maybe<Scalars['Float']>;
  reviewsCount?: Maybe<Scalars['Float']>;
  yelpPriceLevel?: Maybe<Scalars['Float']>;
  yelpRating?: Maybe<Scalars['Float']>;
  yelpRatingsCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "places" */
export type Places_Stddev_Samp_Order_By = {
  googlePriceLevel?: InputMaybe<Order_By>;
  googleRating?: InputMaybe<Order_By>;
  googleRatingsCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  priceLevel?: InputMaybe<Order_By>;
  reviewsCount?: InputMaybe<Order_By>;
  yelpPriceLevel?: InputMaybe<Order_By>;
  yelpRating?: InputMaybe<Order_By>;
  yelpRatingsCount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "places" */
export type Places_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Places_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Places_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  franchiseName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  googlePriceLevel?: InputMaybe<Scalars['Int']>;
  googleRating?: InputMaybe<Scalars['numeric']>;
  googleRatingsCount?: InputMaybe<Scalars['Int']>;
  googleSummary?: InputMaybe<Scalars['String']>;
  googleUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['float8']>;
  lng?: InputMaybe<Scalars['float8']>;
  location?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  priceLevel?: InputMaybe<Scalars['Int']>;
  reviewsCount?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  yelpCategories?: InputMaybe<Scalars['jsonb']>;
  yelpId?: InputMaybe<Scalars['String']>;
  yelpPriceLevel?: InputMaybe<Scalars['Int']>;
  yelpRating?: InputMaybe<Scalars['numeric']>;
  yelpRatingsCount?: InputMaybe<Scalars['Int']>;
  yelpUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Places_Sum_Fields = {
  __typename?: 'places_sum_fields';
  googlePriceLevel?: Maybe<Scalars['Int']>;
  googleRating?: Maybe<Scalars['numeric']>;
  googleRatingsCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['float8']>;
  lng?: Maybe<Scalars['float8']>;
  priceLevel?: Maybe<Scalars['Int']>;
  reviewsCount?: Maybe<Scalars['Int']>;
  yelpPriceLevel?: Maybe<Scalars['Int']>;
  yelpRating?: Maybe<Scalars['numeric']>;
  yelpRatingsCount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "places" */
export type Places_Sum_Order_By = {
  googlePriceLevel?: InputMaybe<Order_By>;
  googleRating?: InputMaybe<Order_By>;
  googleRatingsCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  priceLevel?: InputMaybe<Order_By>;
  reviewsCount?: InputMaybe<Order_By>;
  yelpPriceLevel?: InputMaybe<Order_By>;
  yelpRating?: InputMaybe<Order_By>;
  yelpRatingsCount?: InputMaybe<Order_By>;
};

/** update columns of table "places" */
export enum Places_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CoverUrl = 'coverUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FranchiseName = 'franchiseName',
  /** column name */
  GooglePlaceId = 'googlePlaceId',
  /** column name */
  GooglePriceLevel = 'googlePriceLevel',
  /** column name */
  GoogleRating = 'googleRating',
  /** column name */
  GoogleRatingsCount = 'googleRatingsCount',
  /** column name */
  GoogleSummary = 'googleSummary',
  /** column name */
  GoogleUrl = 'googleUrl',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PriceLevel = 'priceLevel',
  /** column name */
  ReviewsCount = 'reviewsCount',
  /** column name */
  State = 'state',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WebsiteUrl = 'websiteUrl',
  /** column name */
  YelpCategories = 'yelpCategories',
  /** column name */
  YelpId = 'yelpId',
  /** column name */
  YelpPriceLevel = 'yelpPriceLevel',
  /** column name */
  YelpRating = 'yelpRating',
  /** column name */
  YelpRatingsCount = 'yelpRatingsCount',
  /** column name */
  YelpUrl = 'yelpUrl'
}

export type Places_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Places_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Places_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Places_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Places_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Places_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Places_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Places_Set_Input>;
  where: Places_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Places_Var_Pop_Fields = {
  __typename?: 'places_var_pop_fields';
  googlePriceLevel?: Maybe<Scalars['Float']>;
  googleRating?: Maybe<Scalars['Float']>;
  googleRatingsCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  priceLevel?: Maybe<Scalars['Float']>;
  reviewsCount?: Maybe<Scalars['Float']>;
  yelpPriceLevel?: Maybe<Scalars['Float']>;
  yelpRating?: Maybe<Scalars['Float']>;
  yelpRatingsCount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "places" */
export type Places_Var_Pop_Order_By = {
  googlePriceLevel?: InputMaybe<Order_By>;
  googleRating?: InputMaybe<Order_By>;
  googleRatingsCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  priceLevel?: InputMaybe<Order_By>;
  reviewsCount?: InputMaybe<Order_By>;
  yelpPriceLevel?: InputMaybe<Order_By>;
  yelpRating?: InputMaybe<Order_By>;
  yelpRatingsCount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Places_Var_Samp_Fields = {
  __typename?: 'places_var_samp_fields';
  googlePriceLevel?: Maybe<Scalars['Float']>;
  googleRating?: Maybe<Scalars['Float']>;
  googleRatingsCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  priceLevel?: Maybe<Scalars['Float']>;
  reviewsCount?: Maybe<Scalars['Float']>;
  yelpPriceLevel?: Maybe<Scalars['Float']>;
  yelpRating?: Maybe<Scalars['Float']>;
  yelpRatingsCount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "places" */
export type Places_Var_Samp_Order_By = {
  googlePriceLevel?: InputMaybe<Order_By>;
  googleRating?: InputMaybe<Order_By>;
  googleRatingsCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  priceLevel?: InputMaybe<Order_By>;
  reviewsCount?: InputMaybe<Order_By>;
  yelpPriceLevel?: InputMaybe<Order_By>;
  yelpRating?: InputMaybe<Order_By>;
  yelpRatingsCount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Places_Variance_Fields = {
  __typename?: 'places_variance_fields';
  googlePriceLevel?: Maybe<Scalars['Float']>;
  googleRating?: Maybe<Scalars['Float']>;
  googleRatingsCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  priceLevel?: Maybe<Scalars['Float']>;
  reviewsCount?: Maybe<Scalars['Float']>;
  yelpPriceLevel?: Maybe<Scalars['Float']>;
  yelpRating?: Maybe<Scalars['Float']>;
  yelpRatingsCount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "places" */
export type Places_Variance_Order_By = {
  googlePriceLevel?: InputMaybe<Order_By>;
  googleRating?: InputMaybe<Order_By>;
  googleRatingsCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  priceLevel?: InputMaybe<Order_By>;
  reviewsCount?: InputMaybe<Order_By>;
  yelpPriceLevel?: InputMaybe<Order_By>;
  yelpRating?: InputMaybe<Order_By>;
  yelpRatingsCount?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "authUsers" */
  authUsers: Array<AuthUsers>;
  /** fetch aggregated fields from the table: "authUsers" */
  authUsers_aggregate: AuthUsers_Aggregate;
  /** fetch data from the table: "autoTagCounts" */
  autoTagCounts: Array<AutoTagCounts>;
  /** fetch aggregated fields from the table: "autoTagCounts" */
  autoTagCounts_aggregate: AutoTagCounts_Aggregate;
  /** An array relationship */
  awards: Array<Awards>;
  /** An aggregate relationship */
  awards_aggregate: Awards_Aggregate;
  /** fetch data from the table: "awards" using primary key columns */
  awards_by_pk?: Maybe<Awards>;
  /** fetch data from the table: "blobs" */
  blobs: Array<Blobs>;
  /** fetch aggregated fields from the table: "blobs" */
  blobs_aggregate: Blobs_Aggregate;
  /** fetch data from the table: "blobs" using primary key columns */
  blobs_by_pk?: Maybe<Blobs>;
  /** An array relationship */
  bookmarks: Array<Bookmarks>;
  /** An aggregate relationship */
  bookmarks_aggregate: Bookmarks_Aggregate;
  /** fetch data from the table: "bookmarks" using primary key columns */
  bookmarks_by_pk?: Maybe<Bookmarks>;
  /** fetch data from the table: "follows" */
  follows: Array<Follows>;
  /** fetch aggregated fields from the table: "follows" */
  follows_aggregate: Follows_Aggregate;
  /** fetch data from the table: "follows" using primary key columns */
  follows_by_pk?: Maybe<Follows>;
  /** fetch data from the table: "franchises" */
  franchises: Array<Franchises>;
  /** fetch aggregated fields from the table: "franchises" */
  franchises_aggregate: Franchises_Aggregate;
  /** fetch data from the table: "franchises" using primary key columns */
  franchises_by_pk?: Maybe<Franchises>;
  /** execute function "nearbyPlaces" which returns "places" */
  nearbyPlaces: Array<Places>;
  /** execute function "nearbyPlaces" and query aggregates on result of table type "places" */
  nearbyPlaces_aggregate: Places_Aggregate;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table: "placeEarnedReactionCounts" */
  placeEarnedReactionCounts: Array<PlaceEarnedReactionCounts>;
  /** fetch aggregated fields from the table: "placeEarnedReactionCounts" */
  placeEarnedReactionCounts_aggregate: PlaceEarnedReactionCounts_Aggregate;
  /** An array relationship */
  places: Array<Places>;
  /** An aggregate relationship */
  places_aggregate: Places_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  places_by_pk?: Maybe<Places>;
  /** An array relationship */
  reactionCounts: Array<ReactionCounts>;
  /** An aggregate relationship */
  reactionCounts_aggregate: ReactionCounts_Aggregate;
  /** An array relationship */
  reactions: Array<Reactions>;
  /** An aggregate relationship */
  reactions_aggregate: Reactions_Aggregate;
  /** fetch data from the table: "reactions" using primary key columns */
  reactions_by_pk?: Maybe<Reactions>;
  /** fetch data from the table: "recommendations" */
  recommendations: Array<Recommendations>;
  /** fetch aggregated fields from the table: "recommendations" */
  recommendations_aggregate: Recommendations_Aggregate;
  /** fetch data from the table: "recommendations" using primary key columns */
  recommendations_by_pk?: Maybe<Recommendations>;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** fetch data from the table: "reviewsAggregateWithTag" */
  reviewsAggregateWithTag: Array<ReviewsAggregateWithTag>;
  /** fetch aggregated fields from the table: "reviewsAggregateWithTag" */
  reviewsAggregateWithTag_aggregate: ReviewsAggregateWithTag_Aggregate;
  /** fetch data from the table: "reviewsLeaderboard" */
  reviewsLeaderboard: Array<ReviewsLeaderboard>;
  /** fetch aggregated fields from the table: "reviewsLeaderboard" */
  reviewsLeaderboard_aggregate: ReviewsLeaderboard_Aggregate;
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  /** fetch data from the table: "reviews" using primary key columns */
  reviews_by_pk?: Maybe<Reviews>;
  /** fetch data from the table: "userEarnedReactionCounts" */
  userEarnedReactionCounts: Array<UserEarnedReactionCounts>;
  /** fetch aggregated fields from the table: "userEarnedReactionCounts" */
  userEarnedReactionCounts_aggregate: UserEarnedReactionCounts_Aggregate;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Query_RootAuthUsersArgs = {
  distinct_on?: InputMaybe<Array<AuthUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUsers_Order_By>>;
  where?: InputMaybe<AuthUsers_Bool_Exp>;
};


export type Query_RootAuthUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUsers_Order_By>>;
  where?: InputMaybe<AuthUsers_Bool_Exp>;
};


export type Query_RootAutoTagCountsArgs = {
  distinct_on?: InputMaybe<Array<AutoTagCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoTagCounts_Order_By>>;
  where?: InputMaybe<AutoTagCounts_Bool_Exp>;
};


export type Query_RootAutoTagCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AutoTagCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoTagCounts_Order_By>>;
  where?: InputMaybe<AutoTagCounts_Bool_Exp>;
};


export type Query_RootAwardsArgs = {
  distinct_on?: InputMaybe<Array<Awards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Order_By>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


export type Query_RootAwards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Awards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Order_By>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


export type Query_RootAwards_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBlobsArgs = {
  distinct_on?: InputMaybe<Array<Blobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Blobs_Order_By>>;
  where?: InputMaybe<Blobs_Bool_Exp>;
};


export type Query_RootBlobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Blobs_Order_By>>;
  where?: InputMaybe<Blobs_Bool_Exp>;
};


export type Query_RootBlobs_By_PkArgs = {
  key: Scalars['String'];
};


export type Query_RootBookmarksArgs = {
  distinct_on?: InputMaybe<Array<Bookmarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bookmarks_Order_By>>;
  where?: InputMaybe<Bookmarks_Bool_Exp>;
};


export type Query_RootBookmarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bookmarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bookmarks_Order_By>>;
  where?: InputMaybe<Bookmarks_Bool_Exp>;
};


export type Query_RootBookmarks_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFollowsArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


export type Query_RootFollows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


export type Query_RootFollows_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFranchisesArgs = {
  distinct_on?: InputMaybe<Array<Franchises_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Franchises_Order_By>>;
  where?: InputMaybe<Franchises_Bool_Exp>;
};


export type Query_RootFranchises_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Franchises_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Franchises_Order_By>>;
  where?: InputMaybe<Franchises_Bool_Exp>;
};


export type Query_RootFranchises_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootNearbyPlacesArgs = {
  args: NearbyPlaces_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootNearbyPlaces_AggregateArgs = {
  args: NearbyPlaces_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlaceEarnedReactionCountsArgs = {
  distinct_on?: InputMaybe<Array<PlaceEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlaceEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<PlaceEarnedReactionCounts_Bool_Exp>;
};


export type Query_RootPlaceEarnedReactionCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlaceEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlaceEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<PlaceEarnedReactionCounts_Bool_Exp>;
};


export type Query_RootPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootPlaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootPlaces_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootReactionCountsArgs = {
  distinct_on?: InputMaybe<Array<ReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReactionCounts_Order_By>>;
  where?: InputMaybe<ReactionCounts_Bool_Exp>;
};


export type Query_RootReactionCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReactionCounts_Order_By>>;
  where?: InputMaybe<ReactionCounts_Bool_Exp>;
};


export type Query_RootReactionsArgs = {
  distinct_on?: InputMaybe<Array<Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reactions_Order_By>>;
  where?: InputMaybe<Reactions_Bool_Exp>;
};


export type Query_RootReactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reactions_Order_By>>;
  where?: InputMaybe<Reactions_Bool_Exp>;
};


export type Query_RootReactions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommendations_Order_By>>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};


export type Query_RootRecommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommendations_Order_By>>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};


export type Query_RootRecommendations_By_PkArgs = {
  fromUserId: Scalars['String'];
  reviewId: Scalars['Int'];
  toUserId: Scalars['String'];
};


export type Query_RootReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootReviewsAggregateWithTagArgs = {
  distinct_on?: InputMaybe<Array<ReviewsAggregateWithTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewsAggregateWithTag_Order_By>>;
  where?: InputMaybe<ReviewsAggregateWithTag_Bool_Exp>;
};


export type Query_RootReviewsAggregateWithTag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReviewsAggregateWithTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewsAggregateWithTag_Order_By>>;
  where?: InputMaybe<ReviewsAggregateWithTag_Bool_Exp>;
};


export type Query_RootReviewsLeaderboardArgs = {
  distinct_on?: InputMaybe<Array<ReviewsLeaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewsLeaderboard_Order_By>>;
  where?: InputMaybe<ReviewsLeaderboard_Bool_Exp>;
};


export type Query_RootReviewsLeaderboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReviewsLeaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewsLeaderboard_Order_By>>;
  where?: InputMaybe<ReviewsLeaderboard_Bool_Exp>;
};


export type Query_RootReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootReviews_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUserEarnedReactionCountsArgs = {
  distinct_on?: InputMaybe<Array<UserEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<UserEarnedReactionCounts_Bool_Exp>;
};


export type Query_RootUserEarnedReactionCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<UserEarnedReactionCounts_Bool_Exp>;
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['String'];
};

/** columns and relationships of "reactionCounts" */
export type ReactionCounts = {
  __typename?: 'reactionCounts';
  count?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  review?: Maybe<Reviews>;
  reviewId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reactionCounts" */
export type ReactionCounts_Aggregate = {
  __typename?: 'reactionCounts_aggregate';
  aggregate?: Maybe<ReactionCounts_Aggregate_Fields>;
  nodes: Array<ReactionCounts>;
};

export type ReactionCounts_Aggregate_Bool_Exp = {
  count?: InputMaybe<ReactionCounts_Aggregate_Bool_Exp_Count>;
};

export type ReactionCounts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ReactionCounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReactionCounts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reactionCounts" */
export type ReactionCounts_Aggregate_Fields = {
  __typename?: 'reactionCounts_aggregate_fields';
  avg?: Maybe<ReactionCounts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ReactionCounts_Max_Fields>;
  min?: Maybe<ReactionCounts_Min_Fields>;
  stddev?: Maybe<ReactionCounts_Stddev_Fields>;
  stddev_pop?: Maybe<ReactionCounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReactionCounts_Stddev_Samp_Fields>;
  sum?: Maybe<ReactionCounts_Sum_Fields>;
  var_pop?: Maybe<ReactionCounts_Var_Pop_Fields>;
  var_samp?: Maybe<ReactionCounts_Var_Samp_Fields>;
  variance?: Maybe<ReactionCounts_Variance_Fields>;
};


/** aggregate fields of "reactionCounts" */
export type ReactionCounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReactionCounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reactionCounts" */
export type ReactionCounts_Aggregate_Order_By = {
  avg?: InputMaybe<ReactionCounts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ReactionCounts_Max_Order_By>;
  min?: InputMaybe<ReactionCounts_Min_Order_By>;
  stddev?: InputMaybe<ReactionCounts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ReactionCounts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ReactionCounts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ReactionCounts_Sum_Order_By>;
  var_pop?: InputMaybe<ReactionCounts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ReactionCounts_Var_Samp_Order_By>;
  variance?: InputMaybe<ReactionCounts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reactionCounts" */
export type ReactionCounts_Arr_Rel_Insert_Input = {
  data: Array<ReactionCounts_Insert_Input>;
};

/** aggregate avg on columns */
export type ReactionCounts_Avg_Fields = {
  __typename?: 'reactionCounts_avg_fields';
  count?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reactionCounts" */
export type ReactionCounts_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reactionCounts". All fields are combined with a logical 'AND'. */
export type ReactionCounts_Bool_Exp = {
  _and?: InputMaybe<Array<ReactionCounts_Bool_Exp>>;
  _not?: InputMaybe<ReactionCounts_Bool_Exp>;
  _or?: InputMaybe<Array<ReactionCounts_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  review?: InputMaybe<Reviews_Bool_Exp>;
  reviewId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "reactionCounts" */
export type ReactionCounts_Insert_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  review?: InputMaybe<Reviews_Obj_Rel_Insert_Input>;
  reviewId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ReactionCounts_Max_Fields = {
  __typename?: 'reactionCounts_max_fields';
  count?: Maybe<Scalars['bigint']>;
  reviewId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "reactionCounts" */
export type ReactionCounts_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ReactionCounts_Min_Fields = {
  __typename?: 'reactionCounts_min_fields';
  count?: Maybe<Scalars['bigint']>;
  reviewId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "reactionCounts" */
export type ReactionCounts_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "reactionCounts". */
export type ReactionCounts_Order_By = {
  count?: InputMaybe<Order_By>;
  review?: InputMaybe<Reviews_Order_By>;
  reviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "reactionCounts" */
export enum ReactionCounts_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  ReviewId = 'reviewId',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type ReactionCounts_Stddev_Fields = {
  __typename?: 'reactionCounts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reactionCounts" */
export type ReactionCounts_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ReactionCounts_Stddev_Pop_Fields = {
  __typename?: 'reactionCounts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "reactionCounts" */
export type ReactionCounts_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ReactionCounts_Stddev_Samp_Fields = {
  __typename?: 'reactionCounts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "reactionCounts" */
export type ReactionCounts_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reactionCounts" */
export type ReactionCounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReactionCounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReactionCounts_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  reviewId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ReactionCounts_Sum_Fields = {
  __typename?: 'reactionCounts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
  reviewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "reactionCounts" */
export type ReactionCounts_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type ReactionCounts_Var_Pop_Fields = {
  __typename?: 'reactionCounts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "reactionCounts" */
export type ReactionCounts_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ReactionCounts_Var_Samp_Fields = {
  __typename?: 'reactionCounts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "reactionCounts" */
export type ReactionCounts_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ReactionCounts_Variance_Fields = {
  __typename?: 'reactionCounts_variance_fields';
  count?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reactionCounts" */
export type ReactionCounts_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** columns and relationships of "reactions" */
export type Reactions = {
  __typename?: 'reactions';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  review: Reviews;
  reviewId: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};

/** aggregated selection of "reactions" */
export type Reactions_Aggregate = {
  __typename?: 'reactions_aggregate';
  aggregate?: Maybe<Reactions_Aggregate_Fields>;
  nodes: Array<Reactions>;
};

export type Reactions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Reactions_Aggregate_Bool_Exp_Count>;
};

export type Reactions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Reactions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reactions" */
export type Reactions_Aggregate_Fields = {
  __typename?: 'reactions_aggregate_fields';
  avg?: Maybe<Reactions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Reactions_Max_Fields>;
  min?: Maybe<Reactions_Min_Fields>;
  stddev?: Maybe<Reactions_Stddev_Fields>;
  stddev_pop?: Maybe<Reactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reactions_Stddev_Samp_Fields>;
  sum?: Maybe<Reactions_Sum_Fields>;
  var_pop?: Maybe<Reactions_Var_Pop_Fields>;
  var_samp?: Maybe<Reactions_Var_Samp_Fields>;
  variance?: Maybe<Reactions_Variance_Fields>;
};


/** aggregate fields of "reactions" */
export type Reactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reactions" */
export type Reactions_Aggregate_Order_By = {
  avg?: InputMaybe<Reactions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reactions_Max_Order_By>;
  min?: InputMaybe<Reactions_Min_Order_By>;
  stddev?: InputMaybe<Reactions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reactions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reactions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reactions_Sum_Order_By>;
  var_pop?: InputMaybe<Reactions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reactions_Var_Samp_Order_By>;
  variance?: InputMaybe<Reactions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reactions" */
export type Reactions_Arr_Rel_Insert_Input = {
  data: Array<Reactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reactions_On_Conflict>;
};

/** aggregate avg on columns */
export type Reactions_Avg_Fields = {
  __typename?: 'reactions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reactions" */
export type Reactions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reactions". All fields are combined with a logical 'AND'. */
export type Reactions_Bool_Exp = {
  _and?: InputMaybe<Array<Reactions_Bool_Exp>>;
  _not?: InputMaybe<Reactions_Bool_Exp>;
  _or?: InputMaybe<Array<Reactions_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  review?: InputMaybe<Reviews_Bool_Exp>;
  reviewId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "reactions" */
export enum Reactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReactionsPkey = 'reactions_pkey',
  /** unique or primary key constraint on columns "type", "reviewId", "userId" */
  ReactionsUserIdTypeReviewIdKey = 'reactions_userId_type_reviewId_key'
}

/** input type for incrementing numeric columns in table "reactions" */
export type Reactions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  reviewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "reactions" */
export type Reactions_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<Reviews_Obj_Rel_Insert_Input>;
  reviewId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Reactions_Max_Fields = {
  __typename?: 'reactions_max_fields';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  reviewId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "reactions" */
export type Reactions_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reactions_Min_Fields = {
  __typename?: 'reactions_min_fields';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  reviewId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "reactions" */
export type Reactions_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reactions" */
export type Reactions_Mutation_Response = {
  __typename?: 'reactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Reactions>;
};

/** on_conflict condition type for table "reactions" */
export type Reactions_On_Conflict = {
  constraint: Reactions_Constraint;
  update_columns?: Array<Reactions_Update_Column>;
  where?: InputMaybe<Reactions_Bool_Exp>;
};

/** Ordering options when selecting data from "reactions". */
export type Reactions_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review?: InputMaybe<Reviews_Order_By>;
  reviewId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reactions */
export type Reactions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "reactions" */
export enum Reactions_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ReviewId = 'reviewId',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "reactions" */
export type Reactions_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Reactions_Stddev_Fields = {
  __typename?: 'reactions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reactions" */
export type Reactions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reactions_Stddev_Pop_Fields = {
  __typename?: 'reactions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "reactions" */
export type Reactions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reactions_Stddev_Samp_Fields = {
  __typename?: 'reactions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "reactions" */
export type Reactions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reactions" */
export type Reactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reactions_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Reactions_Sum_Fields = {
  __typename?: 'reactions_sum_fields';
  id?: Maybe<Scalars['Int']>;
  reviewId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "reactions" */
export type Reactions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** update columns of table "reactions" */
export enum Reactions_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ReviewId = 'reviewId',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

export type Reactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reactions_Set_Input>;
  where: Reactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reactions_Var_Pop_Fields = {
  __typename?: 'reactions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "reactions" */
export type Reactions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reactions_Var_Samp_Fields = {
  __typename?: 'reactions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "reactions" */
export type Reactions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reactions_Variance_Fields = {
  __typename?: 'reactions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  reviewId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reactions" */
export type Reactions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  reviewId?: InputMaybe<Order_By>;
};

/** columns and relationships of "recommendations" */
export type Recommendations = {
  __typename?: 'recommendations';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  fromUser: Users;
  fromUserId: Scalars['String'];
  /** An object relationship */
  review: Reviews;
  reviewId: Scalars['Int'];
  /** An object relationship */
  toUser: Users;
  toUserId: Scalars['String'];
};

/** aggregated selection of "recommendations" */
export type Recommendations_Aggregate = {
  __typename?: 'recommendations_aggregate';
  aggregate?: Maybe<Recommendations_Aggregate_Fields>;
  nodes: Array<Recommendations>;
};

/** aggregate fields of "recommendations" */
export type Recommendations_Aggregate_Fields = {
  __typename?: 'recommendations_aggregate_fields';
  avg?: Maybe<Recommendations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Recommendations_Max_Fields>;
  min?: Maybe<Recommendations_Min_Fields>;
  stddev?: Maybe<Recommendations_Stddev_Fields>;
  stddev_pop?: Maybe<Recommendations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Recommendations_Stddev_Samp_Fields>;
  sum?: Maybe<Recommendations_Sum_Fields>;
  var_pop?: Maybe<Recommendations_Var_Pop_Fields>;
  var_samp?: Maybe<Recommendations_Var_Samp_Fields>;
  variance?: Maybe<Recommendations_Variance_Fields>;
};


/** aggregate fields of "recommendations" */
export type Recommendations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Recommendations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Recommendations_Avg_Fields = {
  __typename?: 'recommendations_avg_fields';
  reviewId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "recommendations". All fields are combined with a logical 'AND'. */
export type Recommendations_Bool_Exp = {
  _and?: InputMaybe<Array<Recommendations_Bool_Exp>>;
  _not?: InputMaybe<Recommendations_Bool_Exp>;
  _or?: InputMaybe<Array<Recommendations_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fromUser?: InputMaybe<Users_Bool_Exp>;
  fromUserId?: InputMaybe<String_Comparison_Exp>;
  review?: InputMaybe<Reviews_Bool_Exp>;
  reviewId?: InputMaybe<Int_Comparison_Exp>;
  toUser?: InputMaybe<Users_Bool_Exp>;
  toUserId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "recommendations" */
export enum Recommendations_Constraint {
  /** unique or primary key constraint on columns "toUserId", "fromUserId", "reviewId" */
  RecommendationsPkey = 'recommendations_pkey'
}

/** input type for incrementing numeric columns in table "recommendations" */
export type Recommendations_Inc_Input = {
  reviewId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "recommendations" */
export type Recommendations_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  fromUserId?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<Reviews_Obj_Rel_Insert_Input>;
  reviewId?: InputMaybe<Scalars['Int']>;
  toUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  toUserId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Recommendations_Max_Fields = {
  __typename?: 'recommendations_max_fields';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fromUserId?: Maybe<Scalars['String']>;
  reviewId?: Maybe<Scalars['Int']>;
  toUserId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Recommendations_Min_Fields = {
  __typename?: 'recommendations_min_fields';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fromUserId?: Maybe<Scalars['String']>;
  reviewId?: Maybe<Scalars['Int']>;
  toUserId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "recommendations" */
export type Recommendations_Mutation_Response = {
  __typename?: 'recommendations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Recommendations>;
};

/** on_conflict condition type for table "recommendations" */
export type Recommendations_On_Conflict = {
  constraint: Recommendations_Constraint;
  update_columns?: Array<Recommendations_Update_Column>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};

/** Ordering options when selecting data from "recommendations". */
export type Recommendations_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fromUser?: InputMaybe<Users_Order_By>;
  fromUserId?: InputMaybe<Order_By>;
  review?: InputMaybe<Reviews_Order_By>;
  reviewId?: InputMaybe<Order_By>;
  toUser?: InputMaybe<Users_Order_By>;
  toUserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: recommendations */
export type Recommendations_Pk_Columns_Input = {
  fromUserId: Scalars['String'];
  reviewId: Scalars['Int'];
  toUserId: Scalars['String'];
};

/** select columns of table "recommendations" */
export enum Recommendations_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FromUserId = 'fromUserId',
  /** column name */
  ReviewId = 'reviewId',
  /** column name */
  ToUserId = 'toUserId'
}

/** input type for updating data in table "recommendations" */
export type Recommendations_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromUserId?: InputMaybe<Scalars['String']>;
  reviewId?: InputMaybe<Scalars['Int']>;
  toUserId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Recommendations_Stddev_Fields = {
  __typename?: 'recommendations_stddev_fields';
  reviewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Recommendations_Stddev_Pop_Fields = {
  __typename?: 'recommendations_stddev_pop_fields';
  reviewId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Recommendations_Stddev_Samp_Fields = {
  __typename?: 'recommendations_stddev_samp_fields';
  reviewId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "recommendations" */
export type Recommendations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Recommendations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Recommendations_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromUserId?: InputMaybe<Scalars['String']>;
  reviewId?: InputMaybe<Scalars['Int']>;
  toUserId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Recommendations_Sum_Fields = {
  __typename?: 'recommendations_sum_fields';
  reviewId?: Maybe<Scalars['Int']>;
};

/** update columns of table "recommendations" */
export enum Recommendations_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FromUserId = 'fromUserId',
  /** column name */
  ReviewId = 'reviewId',
  /** column name */
  ToUserId = 'toUserId'
}

export type Recommendations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Recommendations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Recommendations_Set_Input>;
  where: Recommendations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Recommendations_Var_Pop_Fields = {
  __typename?: 'recommendations_var_pop_fields';
  reviewId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Recommendations_Var_Samp_Fields = {
  __typename?: 'recommendations_var_samp_fields';
  reviewId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Recommendations_Variance_Fields = {
  __typename?: 'recommendations_variance_fields';
  reviewId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "reviews" */
export type Reviews = {
  __typename?: 'reviews';
  autoTags: Scalars['jsonb'];
  /** An array relationship */
  bookmarks: Array<Bookmarks>;
  bookmarksCount: Scalars['Int'];
  /** An aggregate relationship */
  bookmarks_aggregate: Bookmarks_Aggregate;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** A computed field, executes function "last_activity_at" */
  lastActivityAt?: Maybe<Scalars['timestamptz']>;
  lastReactedAt: Scalars['timestamptz'];
  name: Scalars['String'];
  /** An object relationship */
  parentReview?: Maybe<Reviews>;
  parentReviewId?: Maybe<Scalars['Int']>;
  photoUrl?: Maybe<Scalars['String']>;
  /** An object relationship */
  place: Places;
  placeId: Scalars['Int'];
  rating: Scalars['Int'];
  /** An array relationship */
  reactionCounts: Array<ReactionCounts>;
  /** An aggregate relationship */
  reactionCounts_aggregate: ReactionCounts_Aggregate;
  /** An array relationship */
  reactions: Array<Reactions>;
  /** An aggregate relationship */
  reactions_aggregate: Reactions_Aggregate;
  tags: Scalars['jsonb'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
  verifiedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "reviews" */
export type ReviewsAutoTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "reviews" */
export type ReviewsBookmarksArgs = {
  distinct_on?: InputMaybe<Array<Bookmarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bookmarks_Order_By>>;
  where?: InputMaybe<Bookmarks_Bool_Exp>;
};


/** columns and relationships of "reviews" */
export type ReviewsBookmarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bookmarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bookmarks_Order_By>>;
  where?: InputMaybe<Bookmarks_Bool_Exp>;
};


/** columns and relationships of "reviews" */
export type ReviewsReactionCountsArgs = {
  distinct_on?: InputMaybe<Array<ReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReactionCounts_Order_By>>;
  where?: InputMaybe<ReactionCounts_Bool_Exp>;
};


/** columns and relationships of "reviews" */
export type ReviewsReactionCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReactionCounts_Order_By>>;
  where?: InputMaybe<ReactionCounts_Bool_Exp>;
};


/** columns and relationships of "reviews" */
export type ReviewsReactionsArgs = {
  distinct_on?: InputMaybe<Array<Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reactions_Order_By>>;
  where?: InputMaybe<Reactions_Bool_Exp>;
};


/** columns and relationships of "reviews" */
export type ReviewsReactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reactions_Order_By>>;
  where?: InputMaybe<Reactions_Bool_Exp>;
};


/** columns and relationships of "reviews" */
export type ReviewsTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "reviewsAggregateWithTag" */
export type ReviewsAggregateWithTag = {
  __typename?: 'reviewsAggregateWithTag';
  count?: Maybe<Scalars['bigint']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  photoUrls?: Maybe<Scalars['String']>;
  /** An object relationship */
  place?: Maybe<Places>;
  placeId?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['numeric']>;
  ratings?: Maybe<Scalars['String']>;
  reviewIds?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "reviewsAggregateWithTag" */
export type ReviewsAggregateWithTag_Aggregate = {
  __typename?: 'reviewsAggregateWithTag_aggregate';
  aggregate?: Maybe<ReviewsAggregateWithTag_Aggregate_Fields>;
  nodes: Array<ReviewsAggregateWithTag>;
};

/** aggregate fields of "reviewsAggregateWithTag" */
export type ReviewsAggregateWithTag_Aggregate_Fields = {
  __typename?: 'reviewsAggregateWithTag_aggregate_fields';
  avg?: Maybe<ReviewsAggregateWithTag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ReviewsAggregateWithTag_Max_Fields>;
  min?: Maybe<ReviewsAggregateWithTag_Min_Fields>;
  stddev?: Maybe<ReviewsAggregateWithTag_Stddev_Fields>;
  stddev_pop?: Maybe<ReviewsAggregateWithTag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReviewsAggregateWithTag_Stddev_Samp_Fields>;
  sum?: Maybe<ReviewsAggregateWithTag_Sum_Fields>;
  var_pop?: Maybe<ReviewsAggregateWithTag_Var_Pop_Fields>;
  var_samp?: Maybe<ReviewsAggregateWithTag_Var_Samp_Fields>;
  variance?: Maybe<ReviewsAggregateWithTag_Variance_Fields>;
};


/** aggregate fields of "reviewsAggregateWithTag" */
export type ReviewsAggregateWithTag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReviewsAggregateWithTag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ReviewsAggregateWithTag_Avg_Fields = {
  __typename?: 'reviewsAggregateWithTag_avg_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reviewsAggregateWithTag". All fields are combined with a logical 'AND'. */
export type ReviewsAggregateWithTag_Bool_Exp = {
  _and?: InputMaybe<Array<ReviewsAggregateWithTag_Bool_Exp>>;
  _not?: InputMaybe<ReviewsAggregateWithTag_Bool_Exp>;
  _or?: InputMaybe<Array<ReviewsAggregateWithTag_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photoUrls?: InputMaybe<String_Comparison_Exp>;
  place?: InputMaybe<Places_Bool_Exp>;
  placeId?: InputMaybe<Int_Comparison_Exp>;
  rating?: InputMaybe<Numeric_Comparison_Exp>;
  ratings?: InputMaybe<String_Comparison_Exp>;
  reviewIds?: InputMaybe<String_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type ReviewsAggregateWithTag_Max_Fields = {
  __typename?: 'reviewsAggregateWithTag_max_fields';
  count?: Maybe<Scalars['bigint']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  photoUrls?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['numeric']>;
  ratings?: Maybe<Scalars['String']>;
  reviewIds?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ReviewsAggregateWithTag_Min_Fields = {
  __typename?: 'reviewsAggregateWithTag_min_fields';
  count?: Maybe<Scalars['bigint']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  photoUrls?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['numeric']>;
  ratings?: Maybe<Scalars['String']>;
  reviewIds?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "reviewsAggregateWithTag". */
export type ReviewsAggregateWithTag_Order_By = {
  count?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photoUrls?: InputMaybe<Order_By>;
  place?: InputMaybe<Places_Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  ratings?: InputMaybe<Order_By>;
  reviewIds?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "reviewsAggregateWithTag" */
export enum ReviewsAggregateWithTag_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoUrls = 'photoUrls',
  /** column name */
  PlaceId = 'placeId',
  /** column name */
  Rating = 'rating',
  /** column name */
  Ratings = 'ratings',
  /** column name */
  ReviewIds = 'reviewIds',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type ReviewsAggregateWithTag_Stddev_Fields = {
  __typename?: 'reviewsAggregateWithTag_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ReviewsAggregateWithTag_Stddev_Pop_Fields = {
  __typename?: 'reviewsAggregateWithTag_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ReviewsAggregateWithTag_Stddev_Samp_Fields = {
  __typename?: 'reviewsAggregateWithTag_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "reviewsAggregateWithTag" */
export type ReviewsAggregateWithTag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReviewsAggregateWithTag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReviewsAggregateWithTag_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  photoUrls?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['numeric']>;
  ratings?: InputMaybe<Scalars['String']>;
  reviewIds?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ReviewsAggregateWithTag_Sum_Fields = {
  __typename?: 'reviewsAggregateWithTag_sum_fields';
  count?: Maybe<Scalars['bigint']>;
  placeId?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type ReviewsAggregateWithTag_Var_Pop_Fields = {
  __typename?: 'reviewsAggregateWithTag_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ReviewsAggregateWithTag_Var_Samp_Fields = {
  __typename?: 'reviewsAggregateWithTag_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ReviewsAggregateWithTag_Variance_Fields = {
  __typename?: 'reviewsAggregateWithTag_variance_fields';
  count?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "reviewsLeaderboard" */
export type ReviewsLeaderboard = {
  __typename?: 'reviewsLeaderboard';
  count?: Maybe<Scalars['bigint']>;
  rank?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregated selection of "reviewsLeaderboard" */
export type ReviewsLeaderboard_Aggregate = {
  __typename?: 'reviewsLeaderboard_aggregate';
  aggregate?: Maybe<ReviewsLeaderboard_Aggregate_Fields>;
  nodes: Array<ReviewsLeaderboard>;
};

/** aggregate fields of "reviewsLeaderboard" */
export type ReviewsLeaderboard_Aggregate_Fields = {
  __typename?: 'reviewsLeaderboard_aggregate_fields';
  avg?: Maybe<ReviewsLeaderboard_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ReviewsLeaderboard_Max_Fields>;
  min?: Maybe<ReviewsLeaderboard_Min_Fields>;
  stddev?: Maybe<ReviewsLeaderboard_Stddev_Fields>;
  stddev_pop?: Maybe<ReviewsLeaderboard_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ReviewsLeaderboard_Stddev_Samp_Fields>;
  sum?: Maybe<ReviewsLeaderboard_Sum_Fields>;
  var_pop?: Maybe<ReviewsLeaderboard_Var_Pop_Fields>;
  var_samp?: Maybe<ReviewsLeaderboard_Var_Samp_Fields>;
  variance?: Maybe<ReviewsLeaderboard_Variance_Fields>;
};


/** aggregate fields of "reviewsLeaderboard" */
export type ReviewsLeaderboard_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ReviewsLeaderboard_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ReviewsLeaderboard_Avg_Fields = {
  __typename?: 'reviewsLeaderboard_avg_fields';
  count?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reviewsLeaderboard". All fields are combined with a logical 'AND'. */
export type ReviewsLeaderboard_Bool_Exp = {
  _and?: InputMaybe<Array<ReviewsLeaderboard_Bool_Exp>>;
  _not?: InputMaybe<ReviewsLeaderboard_Bool_Exp>;
  _or?: InputMaybe<Array<ReviewsLeaderboard_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  rank?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type ReviewsLeaderboard_Max_Fields = {
  __typename?: 'reviewsLeaderboard_max_fields';
  count?: Maybe<Scalars['bigint']>;
  rank?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ReviewsLeaderboard_Min_Fields = {
  __typename?: 'reviewsLeaderboard_min_fields';
  count?: Maybe<Scalars['bigint']>;
  rank?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "reviewsLeaderboard". */
export type ReviewsLeaderboard_Order_By = {
  count?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "reviewsLeaderboard" */
export enum ReviewsLeaderboard_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  Rank = 'rank',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type ReviewsLeaderboard_Stddev_Fields = {
  __typename?: 'reviewsLeaderboard_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ReviewsLeaderboard_Stddev_Pop_Fields = {
  __typename?: 'reviewsLeaderboard_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ReviewsLeaderboard_Stddev_Samp_Fields = {
  __typename?: 'reviewsLeaderboard_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "reviewsLeaderboard" */
export type ReviewsLeaderboard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ReviewsLeaderboard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ReviewsLeaderboard_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  rank?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ReviewsLeaderboard_Sum_Fields = {
  __typename?: 'reviewsLeaderboard_sum_fields';
  count?: Maybe<Scalars['bigint']>;
  rank?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type ReviewsLeaderboard_Var_Pop_Fields = {
  __typename?: 'reviewsLeaderboard_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ReviewsLeaderboard_Var_Samp_Fields = {
  __typename?: 'reviewsLeaderboard_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ReviewsLeaderboard_Variance_Fields = {
  __typename?: 'reviewsLeaderboard_variance_fields';
  count?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "reviews" */
export type Reviews_Aggregate = {
  __typename?: 'reviews_aggregate';
  aggregate?: Maybe<Reviews_Aggregate_Fields>;
  nodes: Array<Reviews>;
};

export type Reviews_Aggregate_Bool_Exp = {
  count?: InputMaybe<Reviews_Aggregate_Bool_Exp_Count>;
};

export type Reviews_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Reviews_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reviews" */
export type Reviews_Aggregate_Fields = {
  __typename?: 'reviews_aggregate_fields';
  avg?: Maybe<Reviews_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Reviews_Max_Fields>;
  min?: Maybe<Reviews_Min_Fields>;
  stddev?: Maybe<Reviews_Stddev_Fields>;
  stddev_pop?: Maybe<Reviews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reviews_Stddev_Samp_Fields>;
  sum?: Maybe<Reviews_Sum_Fields>;
  var_pop?: Maybe<Reviews_Var_Pop_Fields>;
  var_samp?: Maybe<Reviews_Var_Samp_Fields>;
  variance?: Maybe<Reviews_Variance_Fields>;
};


/** aggregate fields of "reviews" */
export type Reviews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reviews" */
export type Reviews_Aggregate_Order_By = {
  avg?: InputMaybe<Reviews_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reviews_Max_Order_By>;
  min?: InputMaybe<Reviews_Min_Order_By>;
  stddev?: InputMaybe<Reviews_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reviews_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reviews_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reviews_Sum_Order_By>;
  var_pop?: InputMaybe<Reviews_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reviews_Var_Samp_Order_By>;
  variance?: InputMaybe<Reviews_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Reviews_Append_Input = {
  autoTags?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "reviews" */
export type Reviews_Arr_Rel_Insert_Input = {
  data: Array<Reviews_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};

/** aggregate avg on columns */
export type Reviews_Avg_Fields = {
  __typename?: 'reviews_avg_fields';
  bookmarksCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentReviewId?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "reviews" */
export type Reviews_Avg_Order_By = {
  bookmarksCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentReviewId?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reviews". All fields are combined with a logical 'AND'. */
export type Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Reviews_Bool_Exp>>;
  _not?: InputMaybe<Reviews_Bool_Exp>;
  _or?: InputMaybe<Array<Reviews_Bool_Exp>>;
  autoTags?: InputMaybe<Jsonb_Comparison_Exp>;
  bookmarks?: InputMaybe<Bookmarks_Bool_Exp>;
  bookmarksCount?: InputMaybe<Int_Comparison_Exp>;
  bookmarks_aggregate?: InputMaybe<Bookmarks_Aggregate_Bool_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lastActivityAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  lastReactedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parentReview?: InputMaybe<Reviews_Bool_Exp>;
  parentReviewId?: InputMaybe<Int_Comparison_Exp>;
  photoUrl?: InputMaybe<String_Comparison_Exp>;
  place?: InputMaybe<Places_Bool_Exp>;
  placeId?: InputMaybe<Int_Comparison_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  reactionCounts?: InputMaybe<ReactionCounts_Bool_Exp>;
  reactionCounts_aggregate?: InputMaybe<ReactionCounts_Aggregate_Bool_Exp>;
  reactions?: InputMaybe<Reactions_Bool_Exp>;
  reactions_aggregate?: InputMaybe<Reactions_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
  verifiedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "reviews" */
export enum Reviews_Constraint {
  /** unique or primary key constraint on columns "name", "userId", "placeId" */
  ReviewsNameUserIdPlaceIdKey = 'reviews_name_userId_placeId_key',
  /** unique or primary key constraint on columns "id" */
  ReviewsPkey = 'reviews_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Reviews_Delete_At_Path_Input = {
  autoTags?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Reviews_Delete_Elem_Input = {
  autoTags?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Reviews_Delete_Key_Input = {
  autoTags?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "reviews" */
export type Reviews_Inc_Input = {
  bookmarksCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  parentReviewId?: InputMaybe<Scalars['Int']>;
  placeId?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "reviews" */
export type Reviews_Insert_Input = {
  autoTags?: InputMaybe<Scalars['jsonb']>;
  bookmarks?: InputMaybe<Bookmarks_Arr_Rel_Insert_Input>;
  bookmarksCount?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lastReactedAt?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  parentReview?: InputMaybe<Reviews_Obj_Rel_Insert_Input>;
  parentReviewId?: InputMaybe<Scalars['Int']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Places_Obj_Rel_Insert_Input>;
  placeId?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['Int']>;
  reactionCounts?: InputMaybe<ReactionCounts_Arr_Rel_Insert_Input>;
  reactions?: InputMaybe<Reactions_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Reviews_Max_Fields = {
  __typename?: 'reviews_max_fields';
  bookmarksCount?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lastReactedAt?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  parentReviewId?: Maybe<Scalars['Int']>;
  photoUrl?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "reviews" */
export type Reviews_Max_Order_By = {
  bookmarksCount?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastReactedAt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentReviewId?: InputMaybe<Order_By>;
  photoUrl?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  verifiedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reviews_Min_Fields = {
  __typename?: 'reviews_min_fields';
  bookmarksCount?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lastReactedAt?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  parentReviewId?: Maybe<Scalars['Int']>;
  photoUrl?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "reviews" */
export type Reviews_Min_Order_By = {
  bookmarksCount?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastReactedAt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentReviewId?: InputMaybe<Order_By>;
  photoUrl?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  verifiedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reviews" */
export type Reviews_Mutation_Response = {
  __typename?: 'reviews_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Reviews>;
};

/** input type for inserting object relation for remote table "reviews" */
export type Reviews_Obj_Rel_Insert_Input = {
  data: Reviews_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};

/** on_conflict condition type for table "reviews" */
export type Reviews_On_Conflict = {
  constraint: Reviews_Constraint;
  update_columns?: Array<Reviews_Update_Column>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};

/** Ordering options when selecting data from "reviews". */
export type Reviews_Order_By = {
  autoTags?: InputMaybe<Order_By>;
  bookmarksCount?: InputMaybe<Order_By>;
  bookmarks_aggregate?: InputMaybe<Bookmarks_Aggregate_Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastActivityAt?: InputMaybe<Order_By>;
  lastReactedAt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentReview?: InputMaybe<Reviews_Order_By>;
  parentReviewId?: InputMaybe<Order_By>;
  photoUrl?: InputMaybe<Order_By>;
  place?: InputMaybe<Places_Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  reactionCounts_aggregate?: InputMaybe<ReactionCounts_Aggregate_Order_By>;
  reactions_aggregate?: InputMaybe<Reactions_Aggregate_Order_By>;
  tags?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
  verifiedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reviews */
export type Reviews_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Reviews_Prepend_Input = {
  autoTags?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "reviews" */
export enum Reviews_Select_Column {
  /** column name */
  AutoTags = 'autoTags',
  /** column name */
  BookmarksCount = 'bookmarksCount',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastReactedAt = 'lastReactedAt',
  /** column name */
  Name = 'name',
  /** column name */
  ParentReviewId = 'parentReviewId',
  /** column name */
  PhotoUrl = 'photoUrl',
  /** column name */
  PlaceId = 'placeId',
  /** column name */
  Rating = 'rating',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VerifiedAt = 'verifiedAt'
}

/** input type for updating data in table "reviews" */
export type Reviews_Set_Input = {
  autoTags?: InputMaybe<Scalars['jsonb']>;
  bookmarksCount?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lastReactedAt?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  parentReviewId?: InputMaybe<Scalars['Int']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Reviews_Stddev_Fields = {
  __typename?: 'reviews_stddev_fields';
  bookmarksCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentReviewId?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "reviews" */
export type Reviews_Stddev_Order_By = {
  bookmarksCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentReviewId?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reviews_Stddev_Pop_Fields = {
  __typename?: 'reviews_stddev_pop_fields';
  bookmarksCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentReviewId?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "reviews" */
export type Reviews_Stddev_Pop_Order_By = {
  bookmarksCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentReviewId?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reviews_Stddev_Samp_Fields = {
  __typename?: 'reviews_stddev_samp_fields';
  bookmarksCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentReviewId?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "reviews" */
export type Reviews_Stddev_Samp_Order_By = {
  bookmarksCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentReviewId?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reviews" */
export type Reviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reviews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reviews_Stream_Cursor_Value_Input = {
  autoTags?: InputMaybe<Scalars['jsonb']>;
  bookmarksCount?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lastReactedAt?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  parentReviewId?: InputMaybe<Scalars['Int']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Reviews_Sum_Fields = {
  __typename?: 'reviews_sum_fields';
  bookmarksCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parentReviewId?: Maybe<Scalars['Int']>;
  placeId?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "reviews" */
export type Reviews_Sum_Order_By = {
  bookmarksCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentReviewId?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** update columns of table "reviews" */
export enum Reviews_Update_Column {
  /** column name */
  AutoTags = 'autoTags',
  /** column name */
  BookmarksCount = 'bookmarksCount',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastReactedAt = 'lastReactedAt',
  /** column name */
  Name = 'name',
  /** column name */
  ParentReviewId = 'parentReviewId',
  /** column name */
  PhotoUrl = 'photoUrl',
  /** column name */
  PlaceId = 'placeId',
  /** column name */
  Rating = 'rating',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  VerifiedAt = 'verifiedAt'
}

export type Reviews_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Reviews_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Reviews_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Reviews_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Reviews_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reviews_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Reviews_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reviews_Set_Input>;
  where: Reviews_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reviews_Var_Pop_Fields = {
  __typename?: 'reviews_var_pop_fields';
  bookmarksCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentReviewId?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "reviews" */
export type Reviews_Var_Pop_Order_By = {
  bookmarksCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentReviewId?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reviews_Var_Samp_Fields = {
  __typename?: 'reviews_var_samp_fields';
  bookmarksCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentReviewId?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "reviews" */
export type Reviews_Var_Samp_Order_By = {
  bookmarksCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentReviewId?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reviews_Variance_Fields = {
  __typename?: 'reviews_variance_fields';
  bookmarksCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentReviewId?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "reviews" */
export type Reviews_Variance_Order_By = {
  bookmarksCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentReviewId?: InputMaybe<Order_By>;
  placeId?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "authUsers" */
  authUsers: Array<AuthUsers>;
  /** fetch aggregated fields from the table: "authUsers" */
  authUsers_aggregate: AuthUsers_Aggregate;
  /** fetch data from the table in a streaming manner: "authUsers" */
  authUsers_stream: Array<AuthUsers>;
  /** fetch data from the table: "autoTagCounts" */
  autoTagCounts: Array<AutoTagCounts>;
  /** fetch aggregated fields from the table: "autoTagCounts" */
  autoTagCounts_aggregate: AutoTagCounts_Aggregate;
  /** fetch data from the table in a streaming manner: "autoTagCounts" */
  autoTagCounts_stream: Array<AutoTagCounts>;
  /** An array relationship */
  awards: Array<Awards>;
  /** An aggregate relationship */
  awards_aggregate: Awards_Aggregate;
  /** fetch data from the table: "awards" using primary key columns */
  awards_by_pk?: Maybe<Awards>;
  /** fetch data from the table in a streaming manner: "awards" */
  awards_stream: Array<Awards>;
  /** fetch data from the table: "blobs" */
  blobs: Array<Blobs>;
  /** fetch aggregated fields from the table: "blobs" */
  blobs_aggregate: Blobs_Aggregate;
  /** fetch data from the table: "blobs" using primary key columns */
  blobs_by_pk?: Maybe<Blobs>;
  /** fetch data from the table in a streaming manner: "blobs" */
  blobs_stream: Array<Blobs>;
  /** An array relationship */
  bookmarks: Array<Bookmarks>;
  /** An aggregate relationship */
  bookmarks_aggregate: Bookmarks_Aggregate;
  /** fetch data from the table: "bookmarks" using primary key columns */
  bookmarks_by_pk?: Maybe<Bookmarks>;
  /** fetch data from the table in a streaming manner: "bookmarks" */
  bookmarks_stream: Array<Bookmarks>;
  /** fetch data from the table: "follows" */
  follows: Array<Follows>;
  /** fetch aggregated fields from the table: "follows" */
  follows_aggregate: Follows_Aggregate;
  /** fetch data from the table: "follows" using primary key columns */
  follows_by_pk?: Maybe<Follows>;
  /** fetch data from the table in a streaming manner: "follows" */
  follows_stream: Array<Follows>;
  /** fetch data from the table: "franchises" */
  franchises: Array<Franchises>;
  /** fetch aggregated fields from the table: "franchises" */
  franchises_aggregate: Franchises_Aggregate;
  /** fetch data from the table: "franchises" using primary key columns */
  franchises_by_pk?: Maybe<Franchises>;
  /** fetch data from the table in a streaming manner: "franchises" */
  franchises_stream: Array<Franchises>;
  /** execute function "nearbyPlaces" which returns "places" */
  nearbyPlaces: Array<Places>;
  /** execute function "nearbyPlaces" and query aggregates on result of table type "places" */
  nearbyPlaces_aggregate: Places_Aggregate;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table in a streaming manner: "notifications" */
  notifications_stream: Array<Notifications>;
  /** fetch data from the table: "placeEarnedReactionCounts" */
  placeEarnedReactionCounts: Array<PlaceEarnedReactionCounts>;
  /** fetch aggregated fields from the table: "placeEarnedReactionCounts" */
  placeEarnedReactionCounts_aggregate: PlaceEarnedReactionCounts_Aggregate;
  /** fetch data from the table in a streaming manner: "placeEarnedReactionCounts" */
  placeEarnedReactionCounts_stream: Array<PlaceEarnedReactionCounts>;
  /** An array relationship */
  places: Array<Places>;
  /** An aggregate relationship */
  places_aggregate: Places_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  places_by_pk?: Maybe<Places>;
  /** fetch data from the table in a streaming manner: "places" */
  places_stream: Array<Places>;
  /** An array relationship */
  reactionCounts: Array<ReactionCounts>;
  /** An aggregate relationship */
  reactionCounts_aggregate: ReactionCounts_Aggregate;
  /** fetch data from the table in a streaming manner: "reactionCounts" */
  reactionCounts_stream: Array<ReactionCounts>;
  /** An array relationship */
  reactions: Array<Reactions>;
  /** An aggregate relationship */
  reactions_aggregate: Reactions_Aggregate;
  /** fetch data from the table: "reactions" using primary key columns */
  reactions_by_pk?: Maybe<Reactions>;
  /** fetch data from the table in a streaming manner: "reactions" */
  reactions_stream: Array<Reactions>;
  /** fetch data from the table: "recommendations" */
  recommendations: Array<Recommendations>;
  /** fetch aggregated fields from the table: "recommendations" */
  recommendations_aggregate: Recommendations_Aggregate;
  /** fetch data from the table: "recommendations" using primary key columns */
  recommendations_by_pk?: Maybe<Recommendations>;
  /** fetch data from the table in a streaming manner: "recommendations" */
  recommendations_stream: Array<Recommendations>;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** fetch data from the table: "reviewsAggregateWithTag" */
  reviewsAggregateWithTag: Array<ReviewsAggregateWithTag>;
  /** fetch aggregated fields from the table: "reviewsAggregateWithTag" */
  reviewsAggregateWithTag_aggregate: ReviewsAggregateWithTag_Aggregate;
  /** fetch data from the table in a streaming manner: "reviewsAggregateWithTag" */
  reviewsAggregateWithTag_stream: Array<ReviewsAggregateWithTag>;
  /** fetch data from the table: "reviewsLeaderboard" */
  reviewsLeaderboard: Array<ReviewsLeaderboard>;
  /** fetch aggregated fields from the table: "reviewsLeaderboard" */
  reviewsLeaderboard_aggregate: ReviewsLeaderboard_Aggregate;
  /** fetch data from the table in a streaming manner: "reviewsLeaderboard" */
  reviewsLeaderboard_stream: Array<ReviewsLeaderboard>;
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  /** fetch data from the table: "reviews" using primary key columns */
  reviews_by_pk?: Maybe<Reviews>;
  /** fetch data from the table in a streaming manner: "reviews" */
  reviews_stream: Array<Reviews>;
  /** fetch data from the table: "userEarnedReactionCounts" */
  userEarnedReactionCounts: Array<UserEarnedReactionCounts>;
  /** fetch aggregated fields from the table: "userEarnedReactionCounts" */
  userEarnedReactionCounts_aggregate: UserEarnedReactionCounts_Aggregate;
  /** fetch data from the table in a streaming manner: "userEarnedReactionCounts" */
  userEarnedReactionCounts_stream: Array<UserEarnedReactionCounts>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
};


export type Subscription_RootAuthUsersArgs = {
  distinct_on?: InputMaybe<Array<AuthUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUsers_Order_By>>;
  where?: InputMaybe<AuthUsers_Bool_Exp>;
};


export type Subscription_RootAuthUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUsers_Order_By>>;
  where?: InputMaybe<AuthUsers_Bool_Exp>;
};


export type Subscription_RootAuthUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthUsers_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUsers_Bool_Exp>;
};


export type Subscription_RootAutoTagCountsArgs = {
  distinct_on?: InputMaybe<Array<AutoTagCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoTagCounts_Order_By>>;
  where?: InputMaybe<AutoTagCounts_Bool_Exp>;
};


export type Subscription_RootAutoTagCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AutoTagCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutoTagCounts_Order_By>>;
  where?: InputMaybe<AutoTagCounts_Bool_Exp>;
};


export type Subscription_RootAutoTagCounts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AutoTagCounts_Stream_Cursor_Input>>;
  where?: InputMaybe<AutoTagCounts_Bool_Exp>;
};


export type Subscription_RootAwardsArgs = {
  distinct_on?: InputMaybe<Array<Awards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Order_By>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


export type Subscription_RootAwards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Awards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Order_By>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


export type Subscription_RootAwards_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAwards_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Awards_Stream_Cursor_Input>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


export type Subscription_RootBlobsArgs = {
  distinct_on?: InputMaybe<Array<Blobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Blobs_Order_By>>;
  where?: InputMaybe<Blobs_Bool_Exp>;
};


export type Subscription_RootBlobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Blobs_Order_By>>;
  where?: InputMaybe<Blobs_Bool_Exp>;
};


export type Subscription_RootBlobs_By_PkArgs = {
  key: Scalars['String'];
};


export type Subscription_RootBlobs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Blobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Blobs_Bool_Exp>;
};


export type Subscription_RootBookmarksArgs = {
  distinct_on?: InputMaybe<Array<Bookmarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bookmarks_Order_By>>;
  where?: InputMaybe<Bookmarks_Bool_Exp>;
};


export type Subscription_RootBookmarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bookmarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bookmarks_Order_By>>;
  where?: InputMaybe<Bookmarks_Bool_Exp>;
};


export type Subscription_RootBookmarks_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBookmarks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Bookmarks_Stream_Cursor_Input>>;
  where?: InputMaybe<Bookmarks_Bool_Exp>;
};


export type Subscription_RootFollowsArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


export type Subscription_RootFollows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


export type Subscription_RootFollows_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFollows_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Follows_Stream_Cursor_Input>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


export type Subscription_RootFranchisesArgs = {
  distinct_on?: InputMaybe<Array<Franchises_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Franchises_Order_By>>;
  where?: InputMaybe<Franchises_Bool_Exp>;
};


export type Subscription_RootFranchises_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Franchises_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Franchises_Order_By>>;
  where?: InputMaybe<Franchises_Bool_Exp>;
};


export type Subscription_RootFranchises_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootFranchises_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Franchises_Stream_Cursor_Input>>;
  where?: InputMaybe<Franchises_Bool_Exp>;
};


export type Subscription_RootNearbyPlacesArgs = {
  args: NearbyPlaces_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootNearbyPlaces_AggregateArgs = {
  args: NearbyPlaces_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootNotifications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootPlaceEarnedReactionCountsArgs = {
  distinct_on?: InputMaybe<Array<PlaceEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlaceEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<PlaceEarnedReactionCounts_Bool_Exp>;
};


export type Subscription_RootPlaceEarnedReactionCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlaceEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlaceEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<PlaceEarnedReactionCounts_Bool_Exp>;
};


export type Subscription_RootPlaceEarnedReactionCounts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PlaceEarnedReactionCounts_Stream_Cursor_Input>>;
  where?: InputMaybe<PlaceEarnedReactionCounts_Bool_Exp>;
};


export type Subscription_RootPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPlaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPlaces_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlaces_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Places_Stream_Cursor_Input>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootReactionCountsArgs = {
  distinct_on?: InputMaybe<Array<ReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReactionCounts_Order_By>>;
  where?: InputMaybe<ReactionCounts_Bool_Exp>;
};


export type Subscription_RootReactionCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReactionCounts_Order_By>>;
  where?: InputMaybe<ReactionCounts_Bool_Exp>;
};


export type Subscription_RootReactionCounts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ReactionCounts_Stream_Cursor_Input>>;
  where?: InputMaybe<ReactionCounts_Bool_Exp>;
};


export type Subscription_RootReactionsArgs = {
  distinct_on?: InputMaybe<Array<Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reactions_Order_By>>;
  where?: InputMaybe<Reactions_Bool_Exp>;
};


export type Subscription_RootReactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reactions_Order_By>>;
  where?: InputMaybe<Reactions_Bool_Exp>;
};


export type Subscription_RootReactions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootReactions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Reactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Reactions_Bool_Exp>;
};


export type Subscription_RootRecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommendations_Order_By>>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};


export type Subscription_RootRecommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommendations_Order_By>>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};


export type Subscription_RootRecommendations_By_PkArgs = {
  fromUserId: Scalars['String'];
  reviewId: Scalars['Int'];
  toUserId: Scalars['String'];
};


export type Subscription_RootRecommendations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Recommendations_Stream_Cursor_Input>>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};


export type Subscription_RootReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootReviewsAggregateWithTagArgs = {
  distinct_on?: InputMaybe<Array<ReviewsAggregateWithTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewsAggregateWithTag_Order_By>>;
  where?: InputMaybe<ReviewsAggregateWithTag_Bool_Exp>;
};


export type Subscription_RootReviewsAggregateWithTag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReviewsAggregateWithTag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewsAggregateWithTag_Order_By>>;
  where?: InputMaybe<ReviewsAggregateWithTag_Bool_Exp>;
};


export type Subscription_RootReviewsAggregateWithTag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ReviewsAggregateWithTag_Stream_Cursor_Input>>;
  where?: InputMaybe<ReviewsAggregateWithTag_Bool_Exp>;
};


export type Subscription_RootReviewsLeaderboardArgs = {
  distinct_on?: InputMaybe<Array<ReviewsLeaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewsLeaderboard_Order_By>>;
  where?: InputMaybe<ReviewsLeaderboard_Bool_Exp>;
};


export type Subscription_RootReviewsLeaderboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ReviewsLeaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewsLeaderboard_Order_By>>;
  where?: InputMaybe<ReviewsLeaderboard_Bool_Exp>;
};


export type Subscription_RootReviewsLeaderboard_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ReviewsLeaderboard_Stream_Cursor_Input>>;
  where?: InputMaybe<ReviewsLeaderboard_Bool_Exp>;
};


export type Subscription_RootReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootReviews_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootReviews_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Reviews_Stream_Cursor_Input>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootUserEarnedReactionCountsArgs = {
  distinct_on?: InputMaybe<Array<UserEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<UserEarnedReactionCounts_Bool_Exp>;
};


export type Subscription_RootUserEarnedReactionCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<UserEarnedReactionCounts_Bool_Exp>;
};


export type Subscription_RootUserEarnedReactionCounts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserEarnedReactionCounts_Stream_Cursor_Input>>;
  where?: InputMaybe<UserEarnedReactionCounts_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "userEarnedReactionCounts" */
export type UserEarnedReactionCounts = {
  __typename?: 'userEarnedReactionCounts';
  count?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregated selection of "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Aggregate = {
  __typename?: 'userEarnedReactionCounts_aggregate';
  aggregate?: Maybe<UserEarnedReactionCounts_Aggregate_Fields>;
  nodes: Array<UserEarnedReactionCounts>;
};

export type UserEarnedReactionCounts_Aggregate_Bool_Exp = {
  count?: InputMaybe<UserEarnedReactionCounts_Aggregate_Bool_Exp_Count>;
};

export type UserEarnedReactionCounts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UserEarnedReactionCounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserEarnedReactionCounts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Aggregate_Fields = {
  __typename?: 'userEarnedReactionCounts_aggregate_fields';
  avg?: Maybe<UserEarnedReactionCounts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UserEarnedReactionCounts_Max_Fields>;
  min?: Maybe<UserEarnedReactionCounts_Min_Fields>;
  stddev?: Maybe<UserEarnedReactionCounts_Stddev_Fields>;
  stddev_pop?: Maybe<UserEarnedReactionCounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserEarnedReactionCounts_Stddev_Samp_Fields>;
  sum?: Maybe<UserEarnedReactionCounts_Sum_Fields>;
  var_pop?: Maybe<UserEarnedReactionCounts_Var_Pop_Fields>;
  var_samp?: Maybe<UserEarnedReactionCounts_Var_Samp_Fields>;
  variance?: Maybe<UserEarnedReactionCounts_Variance_Fields>;
};


/** aggregate fields of "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserEarnedReactionCounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Aggregate_Order_By = {
  avg?: InputMaybe<UserEarnedReactionCounts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserEarnedReactionCounts_Max_Order_By>;
  min?: InputMaybe<UserEarnedReactionCounts_Min_Order_By>;
  stddev?: InputMaybe<UserEarnedReactionCounts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UserEarnedReactionCounts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UserEarnedReactionCounts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UserEarnedReactionCounts_Sum_Order_By>;
  var_pop?: InputMaybe<UserEarnedReactionCounts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UserEarnedReactionCounts_Var_Samp_Order_By>;
  variance?: InputMaybe<UserEarnedReactionCounts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Arr_Rel_Insert_Input = {
  data: Array<UserEarnedReactionCounts_Insert_Input>;
};

/** aggregate avg on columns */
export type UserEarnedReactionCounts_Avg_Fields = {
  __typename?: 'userEarnedReactionCounts_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "userEarnedReactionCounts". All fields are combined with a logical 'AND'. */
export type UserEarnedReactionCounts_Bool_Exp = {
  _and?: InputMaybe<Array<UserEarnedReactionCounts_Bool_Exp>>;
  _not?: InputMaybe<UserEarnedReactionCounts_Bool_Exp>;
  _or?: InputMaybe<Array<UserEarnedReactionCounts_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Insert_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserEarnedReactionCounts_Max_Fields = {
  __typename?: 'userEarnedReactionCounts_max_fields';
  count?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserEarnedReactionCounts_Min_Fields = {
  __typename?: 'userEarnedReactionCounts_min_fields';
  count?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "userEarnedReactionCounts". */
export type UserEarnedReactionCounts_Order_By = {
  count?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "userEarnedReactionCounts" */
export enum UserEarnedReactionCounts_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type UserEarnedReactionCounts_Stddev_Fields = {
  __typename?: 'userEarnedReactionCounts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UserEarnedReactionCounts_Stddev_Pop_Fields = {
  __typename?: 'userEarnedReactionCounts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UserEarnedReactionCounts_Stddev_Samp_Fields = {
  __typename?: 'userEarnedReactionCounts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserEarnedReactionCounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserEarnedReactionCounts_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UserEarnedReactionCounts_Sum_Fields = {
  __typename?: 'userEarnedReactionCounts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type UserEarnedReactionCounts_Var_Pop_Fields = {
  __typename?: 'userEarnedReactionCounts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UserEarnedReactionCounts_Var_Samp_Fields = {
  __typename?: 'userEarnedReactionCounts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UserEarnedReactionCounts_Variance_Fields = {
  __typename?: 'userEarnedReactionCounts_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "userEarnedReactionCounts" */
export type UserEarnedReactionCounts_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** An array relationship */
  awards: Array<Awards>;
  /** An aggregate relationship */
  awards_aggregate: Awards_Aggregate;
  bio?: Maybe<Scalars['String']>;
  /** An array relationship */
  bookmarks: Array<Bookmarks>;
  /** An aggregate relationship */
  bookmarks_aggregate: Bookmarks_Aggregate;
  createdAt: Scalars['timestamptz'];
  email?: Maybe<Scalars['String']>;
  /** An array relationship */
  followers: Array<Follows>;
  /** An aggregate relationship */
  followers_aggregate: Follows_Aggregate;
  /** An array relationship */
  followings: Array<Follows>;
  /** An aggregate relationship */
  followings_aggregate: Follows_Aggregate;
  id: Scalars['String'];
  level: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  phone?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  /** An array relationship */
  reactionCounts: Array<UserEarnedReactionCounts>;
  /** An aggregate relationship */
  reactionCounts_aggregate: UserEarnedReactionCounts_Aggregate;
  /** An array relationship */
  reactions: Array<Reactions>;
  /** An aggregate relationship */
  reactions_aggregate: Reactions_Aggregate;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  websiteUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersAwardsArgs = {
  distinct_on?: InputMaybe<Array<Awards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Order_By>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAwards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Awards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Order_By>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBookmarksArgs = {
  distinct_on?: InputMaybe<Array<Bookmarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bookmarks_Order_By>>;
  where?: InputMaybe<Bookmarks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBookmarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bookmarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bookmarks_Order_By>>;
  where?: InputMaybe<Bookmarks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFollowersArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFollowers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFollowingsArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFollowings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Follows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Follows_Order_By>>;
  where?: InputMaybe<Follows_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReactionCountsArgs = {
  distinct_on?: InputMaybe<Array<UserEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<UserEarnedReactionCounts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReactionCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserEarnedReactionCounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEarnedReactionCounts_Order_By>>;
  where?: InputMaybe<UserEarnedReactionCounts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReactionsArgs = {
  distinct_on?: InputMaybe<Array<Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reactions_Order_By>>;
  where?: InputMaybe<Reactions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reactions_Order_By>>;
  where?: InputMaybe<Reactions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  level?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  awards?: InputMaybe<Awards_Bool_Exp>;
  awards_aggregate?: InputMaybe<Awards_Aggregate_Bool_Exp>;
  bio?: InputMaybe<String_Comparison_Exp>;
  bookmarks?: InputMaybe<Bookmarks_Bool_Exp>;
  bookmarks_aggregate?: InputMaybe<Bookmarks_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  followers?: InputMaybe<Follows_Bool_Exp>;
  followers_aggregate?: InputMaybe<Follows_Aggregate_Bool_Exp>;
  followings?: InputMaybe<Follows_Bool_Exp>;
  followings_aggregate?: InputMaybe<Follows_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  level?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  photoUrl?: InputMaybe<String_Comparison_Exp>;
  reactionCounts?: InputMaybe<UserEarnedReactionCounts_Bool_Exp>;
  reactionCounts_aggregate?: InputMaybe<UserEarnedReactionCounts_Aggregate_Bool_Exp>;
  reactions?: InputMaybe<Reactions_Bool_Exp>;
  reactions_aggregate?: InputMaybe<Reactions_Aggregate_Bool_Exp>;
  reviews?: InputMaybe<Reviews_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Bool_Exp>;
  verifiedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  websiteUrl?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "name" */
  UsersNameKey = 'users_name_key',
  /** unique or primary key constraint on columns "phone" */
  UsersPhoneKey = 'users_phone_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  level?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  awards?: InputMaybe<Awards_Arr_Rel_Insert_Input>;
  bio?: InputMaybe<Scalars['String']>;
  bookmarks?: InputMaybe<Bookmarks_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  followers?: InputMaybe<Follows_Arr_Rel_Insert_Input>;
  followings?: InputMaybe<Follows_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<Notifications_Arr_Rel_Insert_Input>;
  phone?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  reactionCounts?: InputMaybe<UserEarnedReactionCounts_Arr_Rel_Insert_Input>;
  reactions?: InputMaybe<Reactions_Arr_Rel_Insert_Input>;
  reviews?: InputMaybe<Reviews_Arr_Rel_Insert_Input>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  bio?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  bio?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  verifiedAt?: Maybe<Scalars['timestamptz']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  awards_aggregate?: InputMaybe<Awards_Aggregate_Order_By>;
  bio?: InputMaybe<Order_By>;
  bookmarks_aggregate?: InputMaybe<Bookmarks_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  followers_aggregate?: InputMaybe<Follows_Aggregate_Order_By>;
  followings_aggregate?: InputMaybe<Follows_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  phone?: InputMaybe<Order_By>;
  photoUrl?: InputMaybe<Order_By>;
  reactionCounts_aggregate?: InputMaybe<UserEarnedReactionCounts_Aggregate_Order_By>;
  reactions_aggregate?: InputMaybe<Reactions_Aggregate_Order_By>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Order_By>;
  verifiedAt?: InputMaybe<Order_By>;
  websiteUrl?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhotoUrl = 'photoUrl',
  /** column name */
  VerifiedAt = 'verifiedAt',
  /** column name */
  WebsiteUrl = 'websiteUrl'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  bio?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  level?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  level?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  level?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  bio?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  verifiedAt?: InputMaybe<Scalars['timestamptz']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  level?: Maybe<Scalars['Int']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhotoUrl = 'photoUrl',
  /** column name */
  VerifiedAt = 'verifiedAt',
  /** column name */
  WebsiteUrl = 'websiteUrl'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  level?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  level?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  level?: Maybe<Scalars['Float']>;
};

export type MyAccountQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type MyAccountQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: string, name?: string | null } | null };

export type MeQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type MeQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: string, name?: string | null } | null };

export type ReviewPlaceQueryVariables = Exact<{
  placeId: Scalars['Int'];
}>;


export type ReviewPlaceQuery = { __typename?: 'query_root', places_by_pk?: { __typename?: 'places', id: number, name: string, reviews: Array<{ __typename?: 'reviews', id: number, name: string, user: { __typename?: 'users', id: string, name?: string | null } }> } | null };

export type CreateReviewMutationVariables = Exact<{
  name: Scalars['String'];
  rating: Scalars['Int'];
  placeId: Scalars['Int'];
  photoUrl: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type CreateReviewMutation = { __typename?: 'mutation_root', insert_reviews_one?: { __typename?: 'reviews', id: number } | null };

export type ReviewsShowQueryVariables = Exact<{
  reviewId: Scalars['Int'];
}>;


export type ReviewsShowQuery = { __typename?: 'query_root', reviews_by_pk?: { __typename?: 'reviews', id: number, name: string, photoUrl?: string | null, rating: number, comment?: string | null, user: { __typename?: 'users', name?: string | null, photoUrl?: string | null, verifiedAt?: any | null }, place: { __typename?: 'places', id: number, name: string, coverUrl?: string | null, address?: string | null, googlePlaceId?: string | null }, comments: Array<{ __typename?: 'reactions', id: number, comment?: string | null, createdAt: any, user: { __typename?: 'users', name?: string | null, photoUrl?: string | null, verifiedAt?: any | null } }> } | null };

export type UsersShowQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type UsersShowQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, name?: string | null, photoUrl?: string | null, verifiedAt?: any | null, reviews: Array<{ __typename?: 'reviews', id: number, name: string, photoUrl?: string | null }> }> };


export const MyAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<MyAccountQuery, MyAccountQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const ReviewPlaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReviewPlace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReviewPlaceQuery, ReviewPlaceQueryVariables>;
export const CreateReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photoUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_reviews_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"placeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"photoUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photoUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateReviewMutation, CreateReviewMutationVariables>;
export const ReviewsShowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReviewsShow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"googlePlaceId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"comments"},"name":{"kind":"Name","value":"reactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReviewsShowQuery, ReviewsShowQueryVariables>;
export const UsersShowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersShow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}}]}}]}}]}}]} as unknown as DocumentNode<UsersShowQuery, UsersShowQueryVariables>;